// This Source Code Form is subject to the terms of the Mozilla Public
// License, v. 2.0. If a copy of the MPL was not distributed with this
// file, You can obtain one at http://mozilla.org/MPL/2.0/
// Variable to hold current primary touch event identifier.
// iOS needs this since it does not attribute
// identifier 0 to primary touch event.
var $aae0d53b42c40933$var$primaryTouchId = null;
// Variable to hold mouse pointer captures.
var $aae0d53b42c40933$var$mouseCaptureTarget = null;
if (!("PointerEvent" in window)) {
    // Define {set,release}PointerCapture
    $aae0d53b42c40933$var$definePointerCapture();
    // Create Pointer polyfill from mouse events only on non-touch device
    if (!("TouchEvent" in window)) {
        $aae0d53b42c40933$var$addMouseToPointerListener(document, "mousedown", "pointerdown");
        $aae0d53b42c40933$var$addMouseToPointerListener(document, "mousemove", "pointermove");
        $aae0d53b42c40933$var$addMouseToPointerListener(document, "mouseup", "pointerup");
    }
    // Define Pointer polyfill from touch events
    $aae0d53b42c40933$var$addTouchToPointerListener(document, "touchstart", "pointerdown");
    $aae0d53b42c40933$var$addTouchToPointerListener(document, "touchmove", "pointermove");
    $aae0d53b42c40933$var$addTouchToPointerListener(document, "touchend", "pointerup");
}
// Function defining {set,release}PointerCapture from {set,releas}Capture
function $aae0d53b42c40933$var$definePointerCapture() {
    Element.prototype.setPointerCapture = Element.prototype.setCapture;
    Element.prototype.releasePointerCapture = Element.prototype.releaseCapture;
}
// Function converting a Mouse event to a Pointer event.
function $aae0d53b42c40933$var$addMouseToPointerListener(target, mouseType, pointerType) {
    target.addEventListener(mouseType, function(mouseEvent) {
        var pointerEvent = new MouseEvent(pointerType, mouseEvent);
        pointerEvent.pointerId = 1;
        pointerEvent.isPrimary = true;
        pointerEvent.pointerType = "mouse";
        pointerEvent.width = 1;
        pointerEvent.height = 1;
        pointerEvent.tiltX = 0;
        pointerEvent.tiltY = 0;
        // pressure is 0.5 if a button is holded
        "buttons" in mouseEvent && mouseEvent.buttons !== 0 ? pointerEvent.pressure = 0.5 : pointerEvent.pressure = 0;
        // if already capturing mouse event, transfer target
        // and don't forget implicit release on mouseup.
        var target = mouseEvent.target;
        if ($aae0d53b42c40933$var$mouseCaptureTarget !== null) {
            target = $aae0d53b42c40933$var$mouseCaptureTarget;
            if (mouseType === "mouseup") $aae0d53b42c40933$var$mouseCaptureTarget = null;
        }
        target.dispatchEvent(pointerEvent);
        if (pointerEvent.defaultPrevented) mouseEvent.preventDefault();
    });
}
// Function converting a Touch event to a Pointer event.
function $aae0d53b42c40933$var$addTouchToPointerListener(target, touchType, pointerType) {
    target.addEventListener(touchType, function(touchEvent) {
        var changedTouches = touchEvent.changedTouches;
        var nbTouches = changedTouches.length;
        for(var t = 0; t < nbTouches; t++){
            var pointerEvent = new CustomEvent(pointerType, {
                bubbles: true,
                cancelable: true
            });
            pointerEvent.ctrlKey = touchEvent.ctrlKey;
            pointerEvent.shiftKey = touchEvent.shiftKey;
            pointerEvent.altKey = touchEvent.altKey;
            pointerEvent.metaKey = touchEvent.metaKey;
            var touch = changedTouches.item(t);
            pointerEvent.clientX = touch.clientX;
            pointerEvent.clientY = touch.clientY;
            pointerEvent.screenX = touch.screenX;
            pointerEvent.screenY = touch.screenY;
            pointerEvent.pageX = touch.pageX;
            pointerEvent.pageY = touch.pageY;
            var rect = touch.target.getBoundingClientRect();
            pointerEvent.offsetX = touch.clientX - rect.left;
            pointerEvent.offsetY = touch.clientY - rect.top;
            pointerEvent.pointerId = 1 + touch.identifier;
            // Default values for standard MouseEvent fields.
            pointerEvent.button = 0;
            pointerEvent.buttons = 1;
            pointerEvent.movementX = 0;
            pointerEvent.movementY = 0;
            pointerEvent.region = null;
            pointerEvent.relatedTarget = null;
            pointerEvent.x = pointerEvent.clientX;
            pointerEvent.y = pointerEvent.clientY;
            // Pointer event details
            pointerEvent.pointerType = "touch";
            pointerEvent.width = 1;
            pointerEvent.height = 1;
            pointerEvent.tiltX = 0;
            pointerEvent.tiltY = 0;
            pointerEvent.pressure = 1;
            // First touch is the primary pointer event.
            if (touchType === "touchstart" && $aae0d53b42c40933$var$primaryTouchId === null) $aae0d53b42c40933$var$primaryTouchId = touch.identifier;
            pointerEvent.isPrimary = touch.identifier === $aae0d53b42c40933$var$primaryTouchId;
            // If first touch ends, reset primary touch id.
            if (touchType === "touchend" && pointerEvent.isPrimary) $aae0d53b42c40933$var$primaryTouchId = null;
            touchEvent.target.dispatchEvent(pointerEvent);
            if (pointerEvent.defaultPrevented) touchEvent.preventDefault();
        }
    });
}


var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return n(r, e, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return n(r, e, t, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, e, t, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, e, t, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return n(r, e, t, u, a, i, o, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, u) {
        return 4 === n.a ? n.f(r, e, t, u) : n(r)(e)(t)(u);
    }
    function A5(n, r, e, t, u, a) {
        return 5 === n.a ? n.f(r, e, t, u, a) : n(r)(e)(t)(u)(a);
    }
    function A6(n, r, e, t, u, a, i) {
        return 6 === n.a ? n.f(r, e, t, u, a, i) : n(r)(e)(t)(u)(a)(i);
    }
    function A7(n, r, e, t, u, a, i, o) {
        return 7 === n.a ? n.f(r, e, t, u, a, i, o) : n(r)(e)(t)(u)(a)(i)(o);
    }
    var e = F3(function(n, r, e) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = e(r + u);
        return t;
    }), t = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, s(e, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var e, t = [], u = i(n, r, 0, t); u && (e = t.pop()); u = i(e.a, e.b, 0, t));
        return u;
    }
    function i(n, r, e, t) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (e > 100) return t.push(s(n, r)), !0;
        for(var a in 0 > n.$ && (n = Br(n), r = Br(r)), n)if (!i(n[a], r[a], e + 1, t)) return !1;
        return !0;
    }
    var o = F2(a);
    function c(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = c(n.a, r.a)) || (e = c(n.b, r.b)) ? e : c(n.c, r.c);
        for(; n.b && r.b && !(e = c(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var f = F2(function(n, r) {
        var e = c(n, r);
        return 0 > e ? Hr : e ? Dr : Sr;
    });
    function s(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function l(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function b(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = p(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = p(n.a, r);
        return e;
    }
    var v = {
        $: 0
    };
    function p(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var m = F2(p);
    function h(n) {
        for(var r = v, e = n.length; e--;)r = p(n[e], r);
        return r;
    }
    function g(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var w = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return h(t);
    }), x = F2(function(n, r) {
        return h(g(r).sort(function(r, e) {
            return c(n(r), n(e));
        }));
    }), y = F2(function(n, r) {
        return n + r;
    }), $ = F2(function(n, r) {
        return n * r;
    }), k = F2(Math.pow), j = F2(function(n, r) {
        var e = r % n;
        return 0 === n ? u(11) : e > 0 && 0 > n || 0 > e && n > 0 ? e + n : e;
    }), z = Math.ceil, G = Math.floor, _ = Math.round, C = Math.log, A = isNaN, B = F2(function(n, r) {
        return n + r;
    }), S = F3(function(n, r, e) {
        for(var t = e.length; t--;){
            var u = e[t], a = e.charCodeAt(t);
            56320 > a || a > 57343 || (u = e[--t] + u), r = A2(n, u, r);
        }
        return r;
    }), D = F2(function(n, r) {
        return r.split(n);
    }), H = F2(function(n, r) {
        return r.join(n);
    }), I = F3(function(n, r, e) {
        return e.slice(n, r);
    }), Q = F2(function(n, r) {
        for(var e = r.length; e--;){
            var t = r[e], u = r.charCodeAt(e);
            if (56320 > u || u > 57343 || (t = r[--e] + t), !n(t)) return !1;
        }
        return !0;
    }), T = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), L = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    });
    function P(n) {
        return n + "";
    }
    function E(n) {
        return {
            $: 2,
            b: n
        };
    }
    var q = E(function(n) {
        return "number" != typeof n ? un("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Pr(n) : !isFinite(n) || n % 1 ? un("an INT", n) : Pr(n);
    }), X = E(function(n) {
        return "boolean" == typeof n ? Pr(n) : un("a BOOL", n);
    }), O = E(function(n) {
        return "number" == typeof n ? Pr(n) : un("a FLOAT", n);
    }), Y = E(function(n) {
        return Pr(n);
    }), N = E(function(n) {
        return "string" == typeof n ? Pr(n) : n instanceof String ? Pr(n + "") : un("a STRING", n);
    }), M = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function F(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), K = F2(function(n, r) {
        return F(n, [
            r
        ]);
    }), U = F3(function(n, r, e) {
        return F(n, [
            r,
            e
        ]);
    }), J = F5(function(n, r, e, t, u) {
        return F(n, [
            r,
            e,
            t,
            u
        ]);
    }), V = F6(function(n, r, e, t, u, a) {
        return F(n, [
            r,
            e,
            t,
            u,
            a
        ]);
    }), W = F7(function(n, r, e, t, u, a, i) {
        return F(n, [
            r,
            e,
            t,
            u,
            a,
            i
        ]);
    }), Z = F2(function(n, r) {
        return nn(n, r);
    });
    function nn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Pr(n.c) : un("null", r);
            case 3:
                return en(r) ? rn(n.b, r, h) : un("a LIST", r);
            case 4:
                return en(r) ? rn(n.b, r, tn) : un("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return un("an OBJECT with a field named `" + e + "`", r);
                var t = nn(n.b, r[e]);
                return Se(t) ? t : Ir(A2(Tr, e, t.a));
            case 7:
                var u = n.e;
                return en(r) ? r.length > u ? (t = nn(n.b, r[u]), Se(t) ? t : Ir(A2(Lr, u, t.a))) : un("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : un("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || en(r)) return un("an OBJECT", r);
                var a = v;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (t = nn(n.b, r[i]), !Se(t)) return Ir(A2(Tr, i, t.a));
                    a = p(s(i, t.a), a);
                }
                return Pr(ae(a));
            case 9:
                for(var o = n.f, c = n.g, f = 0; c.length > f; f++){
                    if (t = nn(c[f], r), !Se(t)) return t;
                    o = o(t.a);
                }
                return Pr(o);
            case 10:
                return t = nn(n.b, r), Se(t) ? nn(n.h(t.a), r) : t;
            case 11:
                for(var l = v, b = n.g; b.b; b = b.b){
                    if (t = nn(b.a, r), Se(t)) return t;
                    l = p(t.a, l);
                }
                return Ir(Er(ae(l)));
            case 1:
                return Ir(A2(Qr, n.a, r));
            case 0:
                return Pr(n.a);
        }
    }
    function rn(n, r, e) {
        for(var t = r.length, u = Array(t), a = 0; t > a; a++){
            var i = nn(n, r[a]);
            if (!Se(i)) return Ir(A2(Lr, a, i.a));
            u[a] = i.a;
        }
        return Pr(e(u));
    }
    function en(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function tn(n) {
        return A2(Be, n.length, function(r) {
            return n[r];
        });
    }
    function un(n, r) {
        return Ir(A2(Qr, "Expecting " + n, r));
    }
    function an(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return an(n.b, r.b);
            case 6:
                return n.d === r.d && an(n.b, r.b);
            case 7:
                return n.e === r.e && an(n.b, r.b);
            case 9:
                return n.f === r.f && on(n.g, r.g);
            case 10:
                return n.h === r.h && an(n.b, r.b);
            case 11:
                return on(n.g, r.g);
        }
    }
    function on(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!an(n[t], r[t])) return !1;
        return !0;
    }
    var cn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function fn(n) {
        return n;
    }
    var sn = F3(function(n, r, e) {
        return e[n] = r, e;
    });
    function ln(n) {
        return {
            $: 0,
            a: n
        };
    }
    function bn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var dn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), vn = 0;
    function pn(n) {
        var r = {
            $: 0,
            e: vn++,
            f: n,
            g: null,
            h: []
        };
        return yn(r), r;
    }
    function mn(n) {
        return bn(function(r) {
            r(ln(pn(n)));
        });
    }
    function hn(n, r) {
        n.h.push(r), yn(n);
    }
    var gn = F2(function(n, r) {
        return bn(function(e) {
            hn(n, r), e(ln(0));
        });
    }), wn = !1, xn = [];
    function yn(n) {
        if (xn.push(n), !wn) {
            for(wn = !0; n = xn.shift();)$n(n);
            wn = !1;
        }
    }
    function $n(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, yn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var kn = {};
    function jn(n, r, e, t, u) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: u
        };
    }
    function zn(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(dn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, e, o, n) : a && i ? A4(t, e, o.i, o.j, n) : A3(t, e, a ? o.i : o.j, n);
                }
            });
        }
        return e.h = pn(A2(dn, o, n.b));
    }
    var Gn = F2(function(n, r) {
        return bn(function(e) {
            n.g(r), e(ln(0));
        });
    }), _n = F2(function(n, r) {
        return A2(gn, n.h, {
            $: 0,
            a: r
        });
    });
    function Cn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function An(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Bn = [], Sn = !1;
    function Dn(n, r, e) {
        if (Bn.push({
            p: n,
            q: r,
            r: e
        }), !Sn) {
            Sn = !0;
            for(var t; t = Bn.shift();)Hn(t.p, t.q, t.r);
            Sn = !1;
        }
    }
    function Hn(n, r, e) {
        var t = {};
        for(var u in In(!0, r, t, null), In(!1, e, t, null), n)hn(n[u], {
            $: "fx",
            a: t[u] || {
                i: v,
                j: v
            }
        });
    }
    function In(n, r, e, t) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, e, t) {
                    function u(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? kn[r].e : kn[r].f, u, t);
                }(n, u, t, r.l);
                return void (e[u] = function(n, r, e) {
                    return e = e || {
                        i: v,
                        j: v
                    }, n ? e.i = p(r, e.i) : e.j = p(r, e.j), e;
                }(n, a, e[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)In(n, i.a, e, t);
                return;
            case 3:
                return void In(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    function Qn(n, r) {
        return function(n) {
            kn[n] && u(3);
        }(n), kn[n] = {
            e: Tn,
            u: r,
            a: Ln
        }, Cn(n);
    }
    var Tn = F2(function(n, r) {
        return r;
    });
    function Ln(n) {
        var r = [], e = kn[n].u, t = bn(function(n) {
            var r = setTimeout(function() {
                n(ln(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return kn[n].b = t, kn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = e(u.a), o = 0; a.length > o; o++)a[o](i);
            return t;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var e = (r = r.slice()).indexOf(n);
                0 > e || r.splice(e, 1);
            }
        };
    }
    var Pn = "undefined" != typeof document ? document : {};
    function En(n, r) {
        n.appendChild(r);
    }
    function qn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Xn = F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Jn(e),
                e: u,
                f: n,
                b: a
            };
        });
    }), On = Xn(void 0);
    F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Jn(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var Yn, Nn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Mn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Fn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Rn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Kn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Un(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    function Jn(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, u = e.n, a = e.o;
            if ("a2" !== t) {
                var i = r[t] || (r[t] = {});
                "a3" === t && "class" === u ? Vn(i, u, a) : i[u] = a;
            } else "className" === u ? Vn(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Vn(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Wn(n, r) {
        var e = n.$;
        if (5 === e) return Wn(n.k || (n.k = n.m()), r);
        if (0 === e) return Pn.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Wn(t, a)).elm_event_node_ref = a, i;
        }
        if (3 === e) return Zn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Pn.createElementNS(n.f, n.c) : Pn.createElement(n.c);
        Zn(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)En(i, Wn(1 === e ? o[c] : o[c].b, r));
        return i;
    }
    function Zn(n, r, e) {
        for(var t in e){
            var u = e[t];
            "a1" === t ? nr(n, u) : "a0" === t ? tr(n, r, u) : "a3" === t ? rr(n, u) : "a4" === t ? er(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function nr(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function rr(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function er(n, r) {
        for(var e in r){
            var t = r[e], u = t.f, a = t.o;
            void 0 !== a ? n.setAttributeNS(u, e, a) : n.removeAttributeNS(u, e);
        }
    }
    function tr(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in e){
            var a = e[u], i = t[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = ur(r, a), n.addEventListener(u, i, Yn && {
                    passive: 2 > Te(a)
                }), t[u] = i;
            } else n.removeEventListener(u, i), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Yn = !0;
            }
        }));
    } catch (n) {}
    function ur(n, r) {
        function e(r) {
            var t = e.q, u = nn(t.a, r);
            if (Se(u)) {
                for(var a, i = Te(t), o = u.a, c = i ? 3 > i ? o.a : o.W : o, f = 1 == i ? o.b : 3 == i && o.bD, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.bz) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return e.q = r, e;
    }
    function ar(n, r) {
        return n.$ == r.$ && an(n.a, r.a);
    }
    function ir(n, r, e, t) {
        var u = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function or(n, r, e, t) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void ir(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), u = 0; e > u; u++)t[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return or(n.k, r.k, s, 0), void (s.length > 0 && ir(e, 1, t, s));
                case 4:
                    for(var l = n.j, b = r.j, d = !1, v = n.k; 4 === v.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var p = r.k; 4 === p.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        p.j
                    ] : b.push(p.j), p = p.k;
                    return d && l.length !== b.length ? void ir(e, 0, t, r) : ((d ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(l, b) : l === b) || ir(e, 2, t, b), void or(v, p, e, t + 1));
                case 0:
                    return void (n.a !== r.a && ir(e, 3, t, r.a));
                case 1:
                    return void cr(n, r, e, t, sr);
                case 2:
                    return void cr(n, r, e, t, lr);
                case 3:
                    if (n.h !== r.h) return void ir(e, 0, t, r);
                    var m = fr(n.d, r.d);
                    m && ir(e, 4, t, m);
                    var h = r.i(n.g, r.g);
                    return void (h && ir(e, 5, t, h));
            }
        }
    }
    function cr(n, r, e, t, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = fr(n.d, r.d);
            a && ir(e, 4, t, a), u(n, r, e, t);
        } else ir(e, 0, t, r);
    }
    function fr(n, r, e) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === e && ar(a, i) || ((t = t || {})[u] = i);
            } else (t = t || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = fr(n[u], r[u] || {}, u);
            o && ((t = t || {})[u] = o);
        }
        for(var c in r)c in n || ((t = t || {})[c] = r[c]);
        return t;
    }
    function sr(n, r, e, t) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? ir(e, 6, t, {
            v: o,
            i: i - o
        }) : o > i && ir(e, 7, t, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            or(s, a[f], e, ++t), t += s.b || 0;
        }
    }
    function lr(n, r, e, t) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, l = 0, b = 0, d = t; f > l && s > b;){
            var v = (G = o[l]).a, p = (_ = c[b]).a, m = G.b, h = _.b, g = void 0, w = void 0;
            if (v !== p) {
                var x = o[l + 1], y = c[b + 1];
                if (x) {
                    var $ = x.a, k = x.b;
                    w = p === $;
                }
                if (y) {
                    var j = y.a, z = y.b;
                    g = v === j;
                }
                if (g && w) or(m, z, u, ++d), dr(a, u, v, h, b, i), d += m.b || 0, vr(a, u, v, k, ++d), d += k.b || 0, l += 2, b += 2;
                else if (g) d++, dr(a, u, p, h, b, i), or(m, z, u, d), d += m.b || 0, l += 1, b += 2;
                else if (w) vr(a, u, v, m, ++d), d += m.b || 0, or(k, h, u, ++d), d += k.b || 0, l += 2, b += 1;
                else {
                    if (!x || $ !== j) break;
                    vr(a, u, v, m, ++d), dr(a, u, p, h, b, i), d += m.b || 0, or(k, z, u, ++d), d += k.b || 0, l += 2, b += 2;
                }
            } else or(m, h, u, ++d), d += m.b || 0, l++, b++;
        }
        for(; f > l;){
            var G;
            d++, vr(a, u, (G = o[l]).a, m = G.b, d), d += m.b || 0, l++;
        }
        for(; s > b;){
            var _, C = C || [];
            dr(a, u, (_ = c[b]).a, _.b, void 0, C), b++;
        }
        (u.length > 0 || i.length > 0 || C) && ir(e, 8, t, {
            w: u,
            x: i,
            y: C
        });
    }
    var br = "_elmW6BL";
    function dr(n, r, e, t, u, a) {
        var i = n[e];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return or(i.z, t, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        dr(n, r, e + br, t, u, a);
    }
    function vr(n, r, e, t, u) {
        var a = n[e];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return or(t, a.z, i, u), void ir(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            vr(n, r, e + br, t, u);
        } else {
            var o = ir(r, 9, u, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: u,
                s: o
            };
        }
    }
    function pr(n, r, e, t) {
        mr(n, r, e, 0, 0, r.b, t);
    }
    function mr(n, r, e, t, u, a, i) {
        for(var o = e[t], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) pr(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && mr(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, l = o.s;
                l && (l.A.s = n, (s = l.w).length > 0 && mr(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = e[++t]) || (c = o.r) > a) return t;
        }
        var b = r.$;
        if (4 === b) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return mr(n, d, e, t, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, p = n.childNodes, m = 0; v.length > m; m++){
            u++;
            var h = 1 === b ? v[m] : v[m].b, g = u + (h.b || 0);
            if (!(u > c || c > g || (o = e[t = mr(p[m], h, e, t, u, g, i)]) && (c = o.r) <= a)) return t;
            u = g;
        }
        return t;
    }
    function hr(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], u = t.t, a = gr(u, t);
            u === n && (n = a);
        }
        return n;
    }
    function gr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, u = Wn(r, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Zn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return hr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var a = (e = r.s).e, i = n.childNodes[t = e.v]; a.length > t; t++)n.insertBefore(Wn(a[t], r.u), i);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var o = e.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = hr(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = Pn.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                En(e, 2 === u.c ? u.s : Wn(u.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = hr(n, e.w);
                    for(var u = e.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Wn(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return t && En(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function wr(n) {
        if (3 === n.nodeType) return qn(n.textContent);
        if (1 !== n.nodeType) return qn("");
        for(var r = v, e = n.attributes, t = e.length; t--;){
            var u = e[t];
            r = p(A2(Kn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = v, o = n.childNodes;
        for(t = o.length; t--;)i = p(wr(o[t]), i);
        return A3(On, a, r, i);
    }
    var xr = F4(function(n, r, e, t) {
        return function(n, r, e, t, a, i) {
            var o = A2(Z, n, r ? r.flags : void 0);
            Se(o) || u(2);
            var c = {}, f = e(o.a), s = f.a, l = i(d, s), b = function(n, r) {
                var e;
                for(var t in kn){
                    var u = kn[t];
                    u.a && ((e = e || {})[t] = u.a(t, r)), n[t] = zn(u, r);
                }
                return e;
            }(c, d);
            function d(n, r) {
                var e = A2(t, n, s);
                l(s = e.a, r), Dn(c, e.b, a(s));
            }
            return Dn(c, f.b, a(s)), b ? {
                ports: b
            } : {};
        }(r, t, n.dR, n.eI, n.ez, function(r, e) {
            var u = n.eJ, a = t.node, i = wr(a);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : ($r(t), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === e && (e = 1)) : (0 === e && $r(t), e = 2);
                };
            }(e, function(n) {
                var e = u(n), t = function(n, r) {
                    var e = [];
                    return or(n, r, e, 0), e;
                }(i, e);
                a = function(n, r, e, t) {
                    return 0 === e.length ? n : (pr(n, r, e, t), hr(n, e));
                }(a, i, t, r), i = e;
            });
        });
    }), yr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, $r = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    var kr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, jr = "undefined" != typeof document ? document : kr, zr = "undefined" != typeof window ? window : kr, Gr = F3(function(n, r, e) {
        return mn(bn(function() {
            function t(n) {
                pn(e(n));
            }
            return n.addEventListener(r, t, Yn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, t);
            };
        }));
    }), _r = F2(function(n, r) {
        var e = nn(n, r);
        return Se(e) ? Xr(e.a) : Or;
    }), Cr = m, Ar = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, u = n, a = A3(n, e.b, e.c, A3(Ar, n, r, e.e));
            n = u, r = a, e = t;
        }
    }), Br = function(n) {
        return A3(Ar, F3(function(n, r, e) {
            return A2(Cr, s(n, r), e);
        }), v, n);
    }, Sr = 1, Dr = 2, Hr = 0, Ir = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Tr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Lr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Pr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Er = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qr = y, Xr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Or = {
        $: 1
    }, Yr = Q, Nr = cn, Mr = P, Fr = F2(function(n, r) {
        return A2(H, n, g(r));
    }), Rr = F2(function(n, r) {
        return h(A2(D, n, r));
    }), Kr = function(n) {
        return A2(Fr, "\n    ", A2(Rr, "\n", n));
    }, Ur = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, u = n, a = A2(n, e.a, r);
            n = u, r = a, e = t;
        }
    }), Jr = function(n) {
        return A3(Ur, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Vr = w, Wr = F3(function(n, r, e) {
        for(;;){
            if (c(n, r) >= 1) return e;
            var t = n, u = r - 1, a = A2(Cr, r, e);
            n = t, r = u, e = a;
        }
    }), Zr = F2(function(n, r) {
        return A3(Wr, n, r, v);
    }), ne = F2(function(n, r) {
        return A3(Vr, n, A2(Zr, 0, Jr(r) - 1), r);
    }), re = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, ee = function(n) {
        var r = re(n);
        return r >= 97 && 122 >= r;
    }, te = function(n) {
        var r = re(n);
        return 90 >= r && r >= 65;
    }, ue = function(n) {
        return ee(n) || te(n) || function(n) {
            var r = re(n);
            return 57 >= r && r >= 48;
        }(n);
    }, ae = function(n) {
        return A3(Ur, Cr, v, n);
    }, ie = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? Or : Xr(55296 > r || r > 56319 ? s(n[0], n.slice(1)) : s(n[0] + n[1], n.slice(2)));
    }, oe = F2(function(n, r) {
        return "\n\n(" + Mr(n + 1) + ") " + Kr(ce(r));
    }), ce = function(n) {
        return A2(fe, n, v);
    }, fe = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, t = n.b, u = function() {
                    var n = ie(e);
                    if (1 === n.$) return !1;
                    var r, t = n.a, u = t.b;
                    return (ee(r = t.a) || te(r)) && A2(Yr, ue, u);
                }();
                n = t, r = A2(Cr, u ? "." + e : "['" + e + "']", r);
                continue n;
            case 1:
                t = n.b;
                var a = "[" + Mr(n.a) + "]";
                n = t, r = A2(Cr, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = (r.b ? "The Json.Decode.oneOf at json" + A2(Fr, "", ae(r)) : "Json.Decode.oneOf") + " failed in the following " + Mr(Jr(i)) + " ways:";
                        return A2(Fr, "\n\n", A2(Cr, o, A2(ne, oe, i)));
                    }
                    n = t = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Fr, "", ae(r)) : "!");
            default:
                var c = n.a, f = n.b;
                return (o = r.b ? "Problem with the value at json" + A2(Fr, "", ae(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Kr(A2(Nr, 4, f)) + "\n\n" + c;
        }
    }), se = 32, le = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), be = [], de = z, ve = F2(function(n, r) {
        return C(r) / C(n);
    }), pe = de(A2(ve, 2, se)), me = A4(le, 0, pe, be, be), he = e, ge = F2(function(n, r) {
        return r(n);
    }), we = o, xe = G, ye = function(n) {
        return n.length;
    }, $e = F2(function(n, r) {
        return c(n, r) > 0 ? n : r;
    }), ke = $, je = t, ze = F2(function(n, r) {
        for(;;){
            var e = A2(je, se, n), t = e.b, u = A2(Cr, {
                $: 0,
                a: e.a
            }, r);
            if (!t.b) return ae(u);
            n = t, r = u;
        }
    }), Ge = function(n) {
        return n.a;
    }, _e = F2(function(n, r) {
        for(;;){
            var e = de(r / se);
            if (1 === e) return A2(je, se, n).a;
            n = A2(ze, n, v), r = e;
        }
    }), Ce = F2(function(n, r) {
        if (r.n) {
            var e = r.n * se, t = xe(A2(ve, se, e - 1)), u = n ? ae(r.r) : r.r, a = A2(_e, u, r.n);
            return A4(le, ye(r.q) + e, A2($e, 5, t * pe), a, r.q);
        }
        return A4(le, ye(r.q), pe, be, r.q);
    }), Ae = F5(function(n, r, e, t, u) {
        for(;;){
            if (0 > r) return A2(Ce, !1, {
                r: t,
                n: e / se | 0,
                q: u
            });
            var a = {
                $: 1,
                a: A3(he, se, r, n)
            };
            r -= se, t = A2(Cr, a, t);
        }
    }), Be = F2(function(n, r) {
        if (n > 0) {
            var e = n % se;
            return A5(Ae, r, n - e - se, n, v, A3(he, e, n - e, r));
        }
        return me;
    }), Se = function(n) {
        return !n.$;
    }, De = R, He = K, Ie = U, Qe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Te = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Le = function(n) {
        return n;
    }, Pe = function(n) {
        return n.length;
    }, Ee = I, qe = F2(function(n, r) {
        return 1 > n ? r : A3(Ee, n, Pe(r), r);
    }), Xe = T, Oe = function() {
        for(;;);
    }, Ye = ln, Ne = Ye(0), Me = F4(function(n, r, e, t) {
        if (t.b) {
            var u = t.a, a = t.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, e > 500 ? A3(Ur, n, r, ae(s)) : A4(Me, n, r, e + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Fe = F3(function(n, r, e) {
        return A4(Me, n, r, 0, e);
    }), Re = F2(function(n, r) {
        return A3(Fe, F2(function(r, e) {
            return A2(Cr, n(r), e);
        }), v, r);
    }), Ke = dn, Ue = F2(function(n, r) {
        return A2(Ke, function(r) {
            return Ye(n(r));
        }, r);
    }), Je = F3(function(n, r, e) {
        return A2(Ke, function(r) {
            return A2(Ke, function(e) {
                return Ye(A2(n, r, e));
            }, e);
        }, r);
    }), Ve = function(n) {
        return A3(Fe, Je(Cr), Ye(v), n);
    }, We = Gn, Ze = F2(function(n, r) {
        var e = r;
        return mn(A2(Ke, We(n), e));
    });
    kn.Task = jn(Ne, F3(function(n, r) {
        return A2(Ue, function() {
            return 0;
        }, Ve(A2(Re, Ze(n), r)));
    }), F3(function() {
        return Ye(0);
    }), F2(function(n, r) {
        return A2(Ue, n, r);
    })), Cn("Task");
    var nt, rt = xr, et = M, tt = h([
        0,
        1,
        2,
        3
    ]), ut = function(n) {
        return {
            $: 3,
            a: n
        };
    }, at = function(n) {
        return {
            $: 1,
            a: n
        };
    }, it = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ot = function(n) {
        return n;
    }, ct = {
        aG: {
            aC: {
                bq: "Drinking Dark Morkite increases the yield of missions",
                G: "beer/beer2.png",
                H: it(.1),
                ar: 1,
                f: "Daily Special"
            },
            G: "beer/dark_morkite.webp",
            ap: "darkMorkite",
            f: "Dark Morkite"
        },
        aS: {
            aC: {
                bq: "Drinking Pots o' Gold increases the XP gain of dwarfs",
                G: "beer/beer2.png",
                H: ut(1),
                ar: 1,
                f: "Daily Special"
            },
            G: "beer/pots_o_gold.webp",
            ap: "potsOGold",
            f: "Pots o' Gold"
        },
        aU: {
            aC: {
                bq: "Drinking Red Rock Blaster increases the yield of missions",
                G: "beer/beer2.png",
                H: it(.3),
                ar: 1,
                f: "Daily Special"
            },
            G: "beer/red_rock_blaster.webp",
            ap: "redRockBlaster",
            f: "Red Rock Blaster"
        },
        aV: {
            aC: {
                bq: "Drinking Rocky Mountain increases the speed of missions",
                G: "beer/beer2.png",
                H: at(.4),
                ar: 1,
                f: "Daily Special"
            },
            G: "beer/rocky_mountain.webp",
            ap: "rockyMountain",
            f: "Rocky Mountain"
        }
    }, ft = F2(function(n, r) {
        switch(r){
            case 0:
                return n.aG;
            case 1:
                return n.aS;
            case 2:
                return n.aU;
            default:
                return n.aV;
        }
    }), st = function(n) {
        return A2(ft, ct, n);
    }, lt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bt = F2(function(n, r) {
        for(;;){
            if (!r.b) return Or;
            var e = r.a, t = r.b;
            if (n(e)) return Xr(e);
            r = t;
        }
    }), dt = N, vt = A2(De, function(n) {
        var r = A2(bt, function(r) {
            return a(st(r).ap, n);
        }, tt);
        return r.$ ? lt("Unknown daily special: " + n) : Qe(r.a);
    }, dt), pt = F2(function(n, r) {
        return s(n, r);
    }), mt = function(n) {
        return {
            $: 11,
            g: n
        };
    }, ht = O, gt = A2(He, ot, ht), wt = A2(He, function(n) {
        return {
            C: n,
            U: !0
        };
    }, A2(et, "current", gt)), xt = X, yt = mt(h([
        A3(Ie, F2(function(n, r) {
            return {
                C: n,
                U: r
            };
        }), A2(et, "current", gt), A2(et, "hasEverTicked", xt)),
        wt
    ])), $t = A3(Ie, pt, A2(et, "dailySpecial", vt), A2(et, "timer", yt)), kt = h([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ]), jt = {
        aA: {
            aw: 3,
            G: "biomes/azureWeald_icon.webp",
            ap: "azureWeald",
            dO: "biomes/azureWeald_image.webp",
            bc: "Azure Weald",
            aY: 5,
            K: 1
        },
        aD: {
            aw: 0,
            G: "biomes/crystallineCaverns_icon.webp",
            ap: "crystallineCaverns",
            dO: "biomes/crystallineCaverns_image4.webp",
            bc: "Crystalline Caverns",
            aY: 1,
            K: 0
        },
        aH: {
            aw: 1,
            G: "biomes/denseBiozone_icon.webp",
            ap: "denseBiozone",
            dO: "biomes/denseBiozone_picture.webp",
            bc: "Dense Biozone",
            aY: 5,
            K: 2
        },
        aJ: {
            aw: 3,
            G: "biomes/fungusBogs_icon.webp",
            ap: "fungusBogs",
            dO: "biomes/fungusBogs_image.webp",
            bc: "Fungus Bogs",
            aY: 0,
            K: 1
        },
        aK: {
            aw: 4,
            G: "biomes/glacialStrata_icon.webp",
            ap: "glacialStrata",
            dO: "biomes/glacialStrata_image.webp",
            bc: "Glacial Strata",
            aY: 5,
            K: 1
        },
        aL: {
            aw: 0,
            G: "biomes/hollowBough_icon.webp",
            ap: "hollowBough",
            dO: "biomes/hollowBough_image.webp",
            bc: "Hollow Bough",
            aY: 3,
            K: 0
        },
        aO: {
            aw: 4,
            G: "biomes/magmaCore_icon.webp",
            ap: "magmaCore",
            dO: "biomes/magmaCore_image.webp",
            bc: "Magma Core",
            aY: 3,
            K: 1
        },
        aT: {
            aw: 5,
            G: "biomes/radioactiveExclusionZone_icon.webp",
            ap: "radioactiveExclusionZone",
            dO: "biomes/radioactiveExclusionZone_image.webp",
            bc: "Radioactive Exclusion Zone",
            aY: 2,
            K: 2
        },
        aW: {
            aw: 2,
            G: "biomes/saltPits_icon.webp",
            ap: "saltPits",
            dO: "biomes/saltPits_image.webp",
            bc: "Salt Pits",
            aY: 1,
            K: 0
        },
        aX: {
            aw: 2,
            G: "biomes/sanblastedCorridors_icon.webp",
            ap: "sandblastedCorridors",
            dO: "biomes/sanblastedCorridors_image.webp",
            bc: "Sandblasted Corridors",
            aY: 4,
            K: 0
        }
    }, zt = F2(function(n, r) {
        switch(r){
            case 0:
                return n.aD;
            case 1:
                return n.aL;
            case 2:
                return n.aW;
            case 3:
                return n.aX;
            case 4:
                return n.aJ;
            case 5:
                return n.aA;
            case 6:
                return n.aK;
            case 7:
                return n.aO;
            case 8:
                return n.aH;
            default:
                return n.aT;
        }
    }), Gt = function(n) {
        return A2(zt, jt, n);
    }, _t = A2(De, function(n) {
        var r = A2(bt, function(r) {
            return a(Gt(r).ap, n);
        }, kt);
        return r.$ ? lt("Unknown biome: " + n) : Qe(r.a);
    }, dt), Ct = function(n) {
        return {
            $: 1,
            a: n
        };
    }, At = {
        $: 0
    }, Bt = function(n) {
        return {
            $: 5,
            c: n
        };
    }, St = mt(h([
        Bt(At),
        A2(He, Ct, yt)
    ])), Dt = {
        C: 0,
        U: !1
    }, Ht = {
        c$: 0,
        c8: !1,
        dF: 1
    }, It = Le, Qt = q, Tt = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Lt = W, Pt = A7(Lt, F6(function(n, r, e, t, u, a) {
        return {
            c4: r,
            di: t,
            dy: e,
            dU: n,
            dY: u,
            eH: a
        };
    }), A2(et, "jadiz", ht), A2(et, "bismor", ht), A2(et, "enorPearl", ht), A2(et, "croppa", ht), A2(et, "magnite", ht), A2(et, "umanite", ht)), Et = Ie(ge), qt = F2(function(n, r) {
        return A3(Fe, et, r, n);
    }), Xt = Z, Ot = Y, Yt = F3(function(n, r, e) {
        var t = function(n) {
            return mt(h([
                n,
                Bt(e)
            ]));
        };
        return A2(De, function(u) {
            var a = A2(Xt, A2(qt, n, Ot), u);
            if (a.$) return Qe(e);
            var i = a.a, o = A2(Xt, t(r), i);
            return o.$ ? A2(qt, n, t(r)) : Qe(o.a);
        }, Ot);
    }), Nt = F4(function(n, r, e, t) {
        return A2(Et, A3(Yt, h([
            n
        ]), r, e), t);
    }), Mt = Le, Ft = A2(He, Mt, Qt), Rt = function(n) {
        return {
            ca: n,
            cf: n,
            cj: n,
            cu: n
        };
    }, Kt = F3(function(n, r, e) {
        return A2(Et, A2(et, n, r), e);
    }), Ut = A2(De, function(n) {
        var r = function(n) {
            switch(n){
                case "default":
                    return Xr(0);
                case "light":
                    return Xr(1);
                case "dark":
                    return Xr(2);
                case "retro":
                    return Xr(3);
                case "cyberpunk":
                    return Xr(4);
                case "black":
                    return Xr(5);
                case "luxury":
                    return Xr(6);
                default:
                    return Or;
            }
        }(n);
        return 1 === r.$ ? lt("Unknown theme: " + n) : Qe(r.a);
    }, dt), Jt = V, Vt = A6(Jt, F5(function(n, r, e, t, u) {
        return {
            dH: n,
            dI: r,
            dJ: e,
            dK: t,
            dL: u
        };
    }), A2(et, "haz1", St), A2(et, "haz2", St), A2(et, "haz3", St), A2(et, "haz4", St), A2(et, "haz5", St)), Wt = J, Zt = function(n) {
        return A5(Wt, F4(function(n, r, e, t) {
            return {
                dq: t,
                dx: e,
                dG: r,
                et: n
            };
        }), A2(et, "scout", n), A2(et, "gunner", n), A2(et, "engineer", n), A2(et, "driller", n));
    }, nu = function(n) {
        return A6(Jt, F5(function(n, r, e, t, u) {
            return {
                dr: n,
                ds: r,
                dt: e,
                du: t,
                dv: u
            };
        }), A2(et, "dwarfXpButton1", n), A2(et, "dwarfXpButton2", n), A2(et, "dwarfXpButton3", n), A2(et, "dwarfXpButton4", n), A2(et, "dwarfXpButton5", n));
    }, ru = h([
        0,
        1,
        2,
        3,
        4
    ]), eu = F2(function(n, r) {
        switch(n){
            case 0:
                return r.d1;
            case 1:
                return r.df;
            case 2:
                return r.en;
            case 3:
                return r.cZ;
            default:
                return r.ev;
        }
    }), tu = Xn("http://www.w3.org/2000/svg"), uu = tu("circle"), au = Kn("cx"), iu = Kn("cy"), ou = Kn("d"), cu = function(n) {
        return {
            a4: Xr("feather feather-" + n),
            ag: 24,
            aZ: "",
            bk: 2,
            bn: "0 0 24 24"
        };
    }, fu = F2(function(n, r) {
        return {
            y: cu(n),
            b: r
        };
    }), su = tu("path"), lu = Kn("r"), bu = A2(fu, "settings", h([
        A2(uu, h([
            au("12"),
            iu("12"),
            lu("3")
        ]), v),
        A2(su, h([
            ou("M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z")
        ]), v)
    ])), du = {
        cZ: {
            aP: Or,
            f: "Abyss Bar"
        },
        df: {
            aP: Or,
            f: "Dwarf Leveling"
        },
        d1: {
            aP: Or,
            f: "Missions"
        },
        en: {
            aP: Or,
            f: "Projects"
        },
        ev: {
            aP: Xr(bu),
            f: "Settings"
        }
    }, vu = A2(De, function(n) {
        var r = A2(bt, function(r) {
            return a(A2(eu, r, du).f, n);
        }, ru);
        return r.$ ? lt("Unknown tab: " + n) : Qe(r.a);
    }, dt), pu = function(n) {
        var r;
        return A2(et, "v0.3", A4(Nt, "projectLevels", (r = Qt, A5(Wt, F4(function(n, r, e, t) {
            return {
                ca: e,
                cf: r,
                cj: n,
                cu: t
            };
        }), A2(et, "mule", r), A2(et, "lloyd", r), A2(et, "jukebox", r), A2(et, "pickaxes", r))), Rt(0), A4(Nt, "missionBiome", A2(He, Xr, _t), Or, A3(Kt, "minerals", Pt, A3(Kt, "dailySpecialCooldown", St, A3(Kt, "dailySpecialOptions", Tt(vt), A3(Kt, "activeDailySpecials", Tt($t), A3(Kt, "dwarfXpButtonStatuses", nu(St), A3(Kt, "dwarfXp", Zt(A2(He, It, ht)), A3(Kt, "missionStatuses", Vt, A3(Kt, "morkite", ht, A3(Kt, "level", Qt, A4(Nt, "theme", A2(He, Xr, Ut), Or, A3(Kt, "currentTab", vu, A3(Kt, "currentTime", Ft, Qe(function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(b) {
                                                        return function(d) {
                                                            return function(v) {
                                                                return {
                                                                    S: f,
                                                                    a6: e,
                                                                    a7: r,
                                                                    aF: l,
                                                                    bo: s,
                                                                    D: Ht,
                                                                    al: o,
                                                                    _: c,
                                                                    h: u,
                                                                    bv: Or,
                                                                    v: b,
                                                                    ac: d,
                                                                    ad: i,
                                                                    aQ: a,
                                                                    as: v,
                                                                    bA: Dt,
                                                                    Q: n,
                                                                    bG: t
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }))))))))))))))));
    }, mu = function(n) {
        return {
            dq: n,
            dx: n,
            dG: n,
            et: n
        };
    }, hu = function(n) {
        return {
            dr: n,
            ds: n,
            dt: n,
            du: n,
            dv: n
        };
    }, gu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wu = function(n) {
        var r = n.b;
        return A2(gu, 1664525 * n.a + r >>> 0, r);
    }, xu = function(n) {
        var r = wu(A2(gu, 0, 1013904223));
        return wu(A2(gu, r.a + n >>> 0, r.b));
    }, yu = function(n) {
        return {
            c4: n,
            di: n,
            dy: n,
            dU: n,
            dY: n,
            eH: n
        };
    }, $u = A7(Lt, F6(function(n, r, e, t, u, a) {
        return {
            S: v,
            a6: e,
            a7: r,
            aF: At,
            bo: h([
                0,
                3
            ]),
            D: Ht,
            al: mu(It(0)),
            _: hu(At),
            h: t,
            bv: Or,
            v: yu(0),
            ac: Or,
            ad: a,
            aQ: u,
            as: Rt(0),
            bA: Dt,
            Q: xu(0),
            bG: Xr(0)
        };
    }), A2(et, "version", A2(De, function(n) {
        return a(n, "v1") ? Qe(0) : lt("This is the parser for v1 but this content is " + n);
    }, dt)), A2(et, "currentTime", Ft), Qe(0), A2(et, "level", Qt), A2(et, "credits", ht), A2(et, "missionStatuses", Vt)), ku = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r), u = t.b;
            return s(n(t.a), u);
        };
    }), ju = function(n) {
        var r = n.a, e = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (e >>> 22 ^ e) >>> 0;
    }, zu = F2(function(n, r) {
        return function(e) {
            var t = 0 > c(n, r) ? s(n, r) : s(r, n), u = t.a, a = t.b - u + 1;
            if (a - 1 & a) {
                var i = (-a >>> 0) % a >>> 0;
                return function(n) {
                    for(;;){
                        var r = ju(n), e = wu(n);
                        if (c(r, i) >= 0) return s(r % a + u, e);
                        n = e;
                    }
                }(e);
            }
            return s(((a - 1 & ju(e)) >>> 0) + u, wu(e));
        };
    }), Gu = A2(zu, -2147483648, 2147483647), _u = F4(function(n, r, e, t) {
        var u = r, a = e, i = t;
        return function(r) {
            var e = u(r), t = e.a, o = a(e.b), c = o.a, f = i(o.b), l = f.b;
            return s(A3(n, t, c, f.a), l);
        };
    }), Cu = F2(function(n, r) {
        return n(r);
    }), Au = function(n) {
        var r = F3(function(n, r, e) {
            return wu(A2(gu, n, (1 | r ^ e) >>> 0));
        }), e = A2(zu, 0, 4294967295);
        return A2(Cu, A4(_u, r, e, e, e), n);
    }, Bu = function(n) {
        return n.b;
    }, Su = x, Du = F3(function(n, r, e) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var t = r.a;
                    n -= 1, r = r.b, e = A2(Cr, t, e);
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), Hu = F2(function(n, r) {
        return ae(A3(Du, n, r, v));
    }), Iu = F3(function(n, r, e) {
        if (r > 0) {
            var t = s(r, e);
            n: for(;;){
                r: for(;;){
                    if (!t.b.b) return e;
                    if (!t.b.b.b) {
                        if (1 === t.a) break n;
                        break r;
                    }
                    switch(t.a){
                        case 1:
                            break n;
                        case 2:
                            var u = t.b;
                            return h([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var a = t.b, i = a.b;
                                return h([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var o = t.b, c = o.b, f = c.b, l = f.b, b = l.b;
                                return A2(Cr, o.a, A2(Cr, c.a, A2(Cr, f.a, A2(Cr, l.a, n > 1e3 ? A2(Hu, r - 4, b) : A3(Iu, n + 1, r - 4, b)))));
                            }
                            break r;
                    }
                }
                return e;
            }
            return h([
                t.b.a
            ]);
        }
        return v;
    }), Qu = F2(function(n, r) {
        return A3(Iu, 0, n, r);
    }), Tu = A2(ku, Qu(2), (nt = tt, A2(ku, function(n) {
        return A2(Re, Ge, A2(Su, Bu, A3(Ur, F2(function(n, r) {
            var e = r.a, t = A2(Cu, Gu, r.b), u = t.b;
            return s(A2(Cr, s(n, t.a), e), u);
        }), s(v, n), nt).a));
    }, Au))), Lu = F2(function(n, r) {
        var e = A2(Cu, Tu, n), t = e.b;
        return {
            S: v,
            a6: 0,
            a7: r,
            aF: At,
            bo: e.a,
            D: Ht,
            al: mu(It(0)),
            _: hu(At),
            h: 1,
            bv: Or,
            v: yu(0),
            ac: Or,
            ad: {
                dH: At,
                dI: At,
                dJ: At,
                dK: At,
                dL: At
            },
            aQ: 0,
            as: Rt(0),
            bA: Dt,
            Q: t,
            bG: Or
        };
    }), Pu = An, Eu = Pu(v), qu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xu = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Ou = An, Yu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nu = F3(function(n, r, e) {
        return {
            by: e,
            cD: r,
            cP: n
        };
    }), Mu = Ye(A3(Nu, v, Or, 0)), Fu = function(n) {
        return bn(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(ln(0));
        });
    }, Ru = bn(function(n) {
        n(ln(Date.now()));
    }), Ku = bn(function(n) {
        var r = $r(function() {
            n(ln(Date.now()));
        });
        return function() {
            yr(r);
        };
    }), Uu = _n, Ju = mn, Vu = F3(function(n, r, e) {
        var t = e.cD, u = e.by, a = s(t, r);
        return 1 === a.a.$ ? a.b.b ? A2(Ke, function(n) {
            return A2(Ke, function(e) {
                return Ye(A3(Nu, r, Xr(n), e));
            }, Ru);
        }, Ju(A2(Ke, Uu(n), Ku))) : Mu : a.b.b ? Ye(A3(Nu, r, t, u)) : A2(Ke, function() {
            return Mu;
        }, Fu(a.a.a));
    }), Wu = F3(function(n, r, e) {
        var t = e.cP, u = e.by, a = function(e) {
            return A2(We, n, (0, e.a)(e.$ ? r - u : Mt(r)));
        };
        return A2(Ke, function(n) {
            return A2(Ke, function() {
                return Ye(A3(Nu, t, Xr(n), r));
            }, Ve(A2(Re, a, t)));
        }, Ju(A2(Ke, Uu(n), Ku)));
    }), Zu = F3(function(n, r, e) {
        return n(r(e));
    });
    kn["Browser.AnimationManager"] = jn(Mu, Vu, Wu, 0, F2(function(n, r) {
        return r.$ ? {
            $: 1,
            a: A2(Zu, n, r.a)
        } : Yu(A2(Zu, n, r.a));
    }));
    var na = Cn("Browser.AnimationManager"), ra = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), ea = F2(function(n, r) {
        return {
            cv: r,
            cP: n
        };
    }), ta = {
        $: -2
    }, ua = ta, aa = Ye(A2(ea, v, ua)), ia = function(n) {
        return s(d(n.a ? "w_" : "d_", n.b), n);
    }, oa = F5(function(n, r, e, t, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), ca = F5(function(n, r, e, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(oa, n, r, e, t, u);
            var a = t.d;
            return i = t.e, A5(oa, 0, t.b, t.c, A5(oa, 1, a.b, a.c, a.d, a.e), A5(oa, 1, r, e, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(oa, n, o, c, A5(oa, 0, r, e, t, f), s) : A5(oa, 0, r, e, A5(oa, 1, t.b, t.c, t.d, i = t.e), A5(oa, 1, o, c, f, s));
    }), fa = f, sa = F3(function(n, r, e) {
        if (-2 === e.$) return A5(oa, 0, n, r, ta, ta);
        var t = e.a, u = e.b, a = e.c, i = e.d, o = e.e;
        switch(A2(fa, n, u)){
            case 0:
                return A5(ca, t, u, a, A3(sa, n, r, i), o);
            case 1:
                return A5(oa, t, u, r, i, o);
            default:
                return A5(ca, t, u, a, i, A3(sa, n, r, o));
        }
    }), la = F3(function(n, r, e) {
        var t = A3(sa, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(oa, 1, t.b, t.c, t.d, t.e);
    }), ba = function(n) {
        return A3(Ur, F2(function(n, r) {
            return A3(la, n.a, n.b, r);
        }), ua, n);
    }, da = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, u = n, a = A3(n, e.b, e.c, A3(da, n, r, e.d));
            n = u, r = a, e = t;
        }
    }), va = F6(function(n, r, e, t, u, a) {
        var i = F3(function(t, u, a) {
            n: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var f = i.a, l = f.a, b = f.b, d = i.b;
                    if (0 > c(l, t)) {
                        a = s(d, A3(n, l, b, o));
                        continue n;
                    }
                    return c(l, t) > 0 ? s(i, A3(e, t, u, o)) : s(d, A4(r, l, b, u, o));
                }
                return s(i, A3(e, t, u, o));
            }
        }), o = A3(da, i, s(Br(t), a), u), f = o.a, l = o.b;
        return A3(Ur, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), l, f);
    }), pa = F2(function(n, r) {
        return {
            bX: r,
            cb: n
        };
    }), ma = F3(function(n, r, e) {
        return A2(Ue, function(n) {
            return s(r, n);
        }, A3(Gr, e.a ? zr : jr, e.b, function(e) {
            return A2(Uu, n, A2(pa, r, e));
        }));
    }), ha = F2(function(n, r) {
        return A3(da, la, r, n);
    }), ga = F3(function(n, r, e) {
        var t = F3(function(r, e, t) {
            var u = t.c;
            return l(t.a, t.b, A2(Cr, A3(ma, n, r, e), u));
        }), u = F3(function(n, r, e) {
            var t = e.b, u = e.c;
            return l(A2(Cr, r, e.a), t, u);
        }), a = F4(function(n, r, e, t) {
            var u = t.c;
            return l(t.a, A3(la, n, r, t.b), u);
        }), i = A2(Re, ia, r), o = A6(va, u, a, t, e.cv, ba(i), l(v, ua, v)), c = o.b, f = o.c;
        return A2(Ke, function(n) {
            return Ye(A2(ea, i, A2(ha, c, ba(n))));
        }, A2(Ke, function() {
            return Ve(f);
        }, Ve(A2(Re, Fu, o.a))));
    }), wa = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(Cr, t.a, e);
    }), xa = F2(function(n, r) {
        return A3(Fe, wa(n), v, r);
    });
    kn["Browser.Events"] = jn(aa, ga, F3(function(n, r, e) {
        var t = r.cb, u = r.bX, i = A2(xa, function(n) {
            var r = n.b.c;
            return a(n.a, t) ? A2(_r, r, u) : Or;
        }, e.cP);
        return A2(Ke, function() {
            return Ye(e);
        }, Ve(A2(Re, We(n), i)));
    }), 0, F2(function(n, r) {
        return A3(ra, r.a, r.b, A2(He, n, r.c));
    }));
    var ya, $a = Cn("Browser.Events"), ka = F3(function(n, r, e) {
        return $a(A3(ra, n, r, e));
    }), ja = A2(ka, 0, "keydown"), za = F3(function(n, r, e) {
        var t = e;
        return A3(Ur, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), r, t);
    }), Ga = F2(function(n, r) {
        switch(r){
            case 0:
                return n.dU;
            case 1:
                return n.c4;
            case 2:
                return n.dy;
            case 3:
                return n.di;
            case 4:
                return n.dY;
            default:
                return n.eH;
        }
    }), _a = F3(function(n, r, e) {
        switch(r){
            case 0:
                return b(e, {
                    dU: n
                });
            case 1:
                return b(e, {
                    c4: n
                });
            case 2:
                return b(e, {
                    dy: n
                });
            case 3:
                return b(e, {
                    di: n
                });
            case 4:
                return b(e, {
                    dY: n
                });
            default:
                return b(e, {
                    eH: n
                });
        }
    }), Ca = F3(function(n, r, e) {
        return A3(_a, n(A2(Ga, r, e)), e, r);
    }), Aa = F2(function(n, r) {
        return A3(za, F3(function(n, r, e) {
            return A3(Ca, qr(r), e, n);
        }), n, r);
    }), Ba = {
        $: 1
    }, Sa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Da = function(n) {
        return 6 > n ? Sa(5 * n) : 12 > n ? Sa(8 * n) : 14 > n ? Sa(10 * n) : 20 > n ? Sa(15 * n) : 25 > n ? Sa(25 * n) : 30 > n ? Sa(35 * n) : Ba;
    }, Ha = F2(function(n, r) {
        for(;;){
            var e = Da(r.h);
            if (e.$) return r;
            var t = r.aQ + n, u = t - e.a;
            if (0 > u) return b(r, {
                aQ: t
            });
            n = u, r = b(r, {
                h: r.h + 1,
                aQ: 0
            });
        }
    }), Ia = h([
        0,
        1,
        2,
        3,
        4
    ]), Qa = h([
        0,
        1,
        2,
        3,
        4
    ]), Ta = F2(function(n, r) {
        return r / n;
    }), La = F2(function(n, r) {
        return r + n;
    }), Pa = F2(function(n, r) {
        var e = function(n) {
            return A3(Ur, La, 0, A2(xa, function(n) {
                return 1 === n.$ ? Xr(n.a) : Or;
            }, n));
        }(r);
        return A2(Ta, 1 + e, n);
    }), Ea = fn, qa = Qn("closePopover", Ea), Xa = 86400, Oa = Xa, Ya = function(n) {
        return 3600 * n;
    }, Na = Ya(20), Ma = {
        $: 1
    }, Fa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ra = function(n) {
        return 1 > n ? Ir(0) : 5 > n ? Pr(Fa(3)) : 11 > n ? Pr(Fa(7)) : 20 > n ? Pr(Fa(15)) : 25 > n ? Pr(Fa(25)) : 25 === n ? Pr(Ma) : Ir(0);
    }, Ka = A2(F2(function(n, r) {
        for(;;){
            var e = Ra(n);
            if (e.$ || e.a.$) return r;
            var t = n + 1, u = d(r, h([
                s(n, It(e.a.a))
            ]));
            n = t, r = u;
        }
    }), 1, v), Ua = function(n) {
        return A3(F3(function(n, r, e) {
            for(;;){
                var t = r;
                if (!e.b) return n;
                var u = e.a.b, a = e.b;
                if (0 > c(t, u)) return n;
                n += 1, r = It(t - u), e = a;
            }
        }), 1, n, Ka);
    }, Ja = F2(function(n, r) {
        return r.$ ? Or : Xr(n(r.a));
    }), Va = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Wa = A2(Va, 1, A2(Ja, Ge, function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return Xr(n.a);
            }
            return Or;
        }
    }(Ka))), Za = {
        $: 6
    }, ni = {
        $: 7
    }, ri = {
        $: 8
    }, ei = {
        $: 9
    }, ti = function(n) {
        return 60 * n;
    }, ui = {
        dr: {
            aI: ti(1),
            ap: "dwarfXpButton1",
            a3: Or,
            bI: It(1)
        },
        ds: {
            aI: ti(5),
            ap: "dwarfXpButton2",
            a3: Xr(Za),
            bI: It(2)
        },
        dt: {
            aI: ti(60),
            ap: "dwarfXpButton3",
            a3: Xr(ni),
            bI: It(3)
        },
        du: {
            aI: ti(360),
            ap: "dwarfXpButton4",
            a3: Xr(ri),
            bI: It(4)
        },
        dv: {
            aI: ti(1440),
            ap: "dwarfXpButton5",
            a3: Xr(ei),
            bI: It(5)
        }
    }, ai = F2(function(n, r) {
        switch(r){
            case 0:
                return n.dr;
            case 1:
                return n.ds;
            case 2:
                return n.dt;
            case 3:
                return n.du;
            default:
                return n.dv;
        }
    }), ii = function(n) {
        return A2(ai, ui, n);
    }, oi = h([
        0,
        1,
        2,
        3
    ]), ci = function(n) {
        switch(n){
            case 0:
                return function(n) {
                    return n.et;
                };
            case 1:
                return function(n) {
                    return n.dG;
                };
            case 2:
                return function(n) {
                    return n.dx;
                };
            default:
                return function(n) {
                    return n.dq;
                };
        }
    }, fi = function(n) {
        return A3(Ur, La, 0, A2(xa, function(n) {
            return 3 === n.$ ? Xr(n.a) : Or;
        }, n));
    }, si = F2(function(n, r) {
        return n * r;
    }), li = F3(function(n, r, e) {
        switch(n){
            case 0:
                return b(e, {
                    et: r
                });
            case 1:
                return b(e, {
                    dG: r
                });
            case 2:
                return b(e, {
                    dx: r
                });
            default:
                return b(e, {
                    dq: r
                });
        }
    }), bi = function(n) {
        return s(1, n);
    }, di = function(n) {
        return 0 > n ? -n : n;
    }, vi = F2(function(n, r) {
        return function(e) {
            var t = wu(e), u = di(r - n), a = ju(t);
            return s((1 * (67108863 & ju(e)) * 134217728 + 1 * (134217727 & a)) / 9007199254740992 * u + n, wu(t));
        };
    }), pi = F3(function(n, r, e) {
        for(;;){
            var t = n.a, u = n.b;
            if (!r.b) return u;
            var a = r.a, i = r.b;
            if (1 > c(e, di(t))) return u;
            n = a, r = i, e -= di(t);
        }
    }), mi = function(n) {
        return A3(Ur, qr, 0, n);
    }, hi = F2(function(n, r) {
        var e = function(n) {
            return di(n.a);
        }, t = e(n) + mi(A2(Re, e, r));
        return A2(ku, A2(pi, n, r), A2(vi, 0, t));
    }), gi = F2(function(n, r) {
        return A2(hi, bi(n), A2(Re, bi, r));
    }), wi = F3(function(n, r, e) {
        var t = fi(e), u = A2(si, 1 + t, n);
        return A2(ku, function(n) {
            return s(n, A3(li, n, A2(La, A2(ci, n, r), u), r));
        }, A2(gi, 0, oi));
    }), xi = v, yi = null, $i = fn, ki = function(n) {
        return A3(Ur, F2(function(n, r) {
            return A3(sn, n.a, n.b, r);
        }), {}, n);
    }, ji = fn, zi = function(n) {
        var r, e = n.U;
        return ki(h([
            s("current", (r = n.C, ji(r))),
            s("hasEverTicked", $i(e))
        ]));
    }, Gi = function(n) {
        return n.$ ? zi(n.a) : yi;
    }, _i = function(n) {
        return Ea(st(n).ap);
    }, Ci = fn, Ai = F2(function(n, r) {
        return A3(Ur, function(n) {
            return F2(function(r, e) {
                return e.push(n(r)), e;
            });
        }(n), [], r);
    }), Bi = function(n) {
        return n.$ ? zi(n.a) : yi;
    }, Si = function(n) {
        switch(n){
            case 0:
                return "default";
            case 1:
                return "light";
            case 2:
                return "dark";
            case 3:
                return "retro";
            case 4:
                return "cyberpunk";
            case 5:
                return "black";
            default:
                return "luxury";
        }
    }, Di = function(n) {
        var r, e, t, u, a;
        return ki(h([
            s("v0.3", ki(h([
                s("currentTime", (a = n.a7, Ci(a))),
                s("currentTab", (u = n.a6, Ea(A2(eu, u, du).f))),
                s("theme", (t = n.bG, 1 === t.$ ? yi : Ea(Si(t.a)))),
                s("level", Ci(n.h)),
                s("morkite", ji(n.aQ)),
                s("missionStatuses", ki(h([
                    s("haz1", Gi(n.ad.dH)),
                    s("haz2", Gi(n.ad.dI)),
                    s("haz3", Gi(n.ad.dJ)),
                    s("haz4", Gi(n.ad.dK)),
                    s("haz5", Gi(n.ad.dL))
                ]))),
                s("dwarfXpButtonStatuses", (e = n._, ki(A2(Re, function(n) {
                    return s(ii(n).ap, Bi(A2(ai, e, n)));
                }, Ia)))),
                s("dwarfXp", ki(h([
                    s("scout", ji(n.al.et)),
                    s("gunner", ji(n.al.dG)),
                    s("engineer", ji(n.al.dx)),
                    s("driller", ji(n.al.dq))
                ]))),
                s("activeDailySpecials", A2(Ai, function(n) {
                    var r = n.b;
                    return ki(h([
                        s("dailySpecial", Ea(st(n.a).ap)),
                        s("timer", zi(r))
                    ]));
                }, n.S)),
                s("dailySpecialCooldown", Bi(n.aF)),
                s("dailySpecialOptions", A2(Ai, _i, n.bo)),
                s("minerals", ki(h([
                    s("jadiz", ji(n.v.dU)),
                    s("bismor", ji(n.v.c4)),
                    s("enorPearl", ji(n.v.dy)),
                    s("croppa", ji(n.v.di)),
                    s("magnite", ji(n.v.dY)),
                    s("umanite", ji(n.v.eH))
                ]))),
                s("missionBiome", (r = n.ac, r.$ ? yi : Ea(Gt(r.a).ap))),
                s("projectLevels", ki(h([
                    s("mule", Ci(n.as.cj)),
                    s("lloyd", Ci(n.as.cf)),
                    s("jukebox", Ci(n.as.ca)),
                    s("pickaxes", Ci(n.as.cu))
                ])))
            ])))
        ]));
    }, Hi = F2(function(n, r) {
        return r.b ? A3(Fe, Cr, r, n) : n;
    }), Ii = function(n) {
        return A3(Fe, Hi, v, n);
    }, Qi = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ti = function(n) {
        var r = n.H;
        switch(r.$){
            case 0:
                return it(A2(si, n.ar, r.a));
            case 1:
                return at(A2(si, n.ar, r.a));
            case 2:
                return Qi(A2(si, n.ar, r.a));
            default:
                return ut(A2(si, n.ar, r.a));
        }
    }, Li = h([
        0,
        1,
        2,
        3
    ]), Pi = F2(function(n, r) {
        switch(r){
            case 0:
                return n.cj;
            case 1:
                return n.cf;
            case 2:
                return n.ca;
            default:
                return n.cu;
        }
    }), Ei = F2(function(n, r) {
        return A3(Fe, F2(function(r, e) {
            return n(r) ? A2(Cr, r, e) : e;
        }), v, r);
    }), qi = F2(function(n, r) {
        return A2(Ei, function(r) {
            return !a(r.a, n);
        }, r);
    }), Xi = F3(function(n, r, e) {
        var t = A2(qi, n, e);
        return A2(Cr, s(n, r), t);
    }), Oi = function(n) {
        return A3(Ur, F2(function(n, r) {
            return A3(Xi, n.a, n.b, r);
        }), v, n);
    }, Yi = {
        ca: {
            aC: {
                bq: "Increases dwarf XP gain",
                G: "jukebox.jpg",
                H: ut(2),
                ar: 1,
                f: "Better Tunes"
            },
            a5: Oi(h([
                s(0, 40),
                s(2, 40)
            ])),
            bu: 2,
            bc: "Jukebox"
        },
        cf: {
            aC: {
                bq: "Increases the strength of daily specials",
                G: "lloyd.jpg",
                H: Qi(1),
                ar: 1,
                f: "Frothier Drinks"
            },
            a5: Oi(h([
                s(4, 40),
                s(5, 40)
            ])),
            bu: 2,
            bc: "Lloyd"
        },
        cj: {
            aC: {
                bq: "Increases mission yield",
                G: "mule.webp",
                H: it(1),
                ar: 1,
                f: "M.U.L.E."
            },
            a5: Oi(h([
                s(1, 20),
                s(3, 20)
            ])),
            bu: 2,
            bc: "M.U.L.E. storage"
        },
        cu: {
            aC: {
                bq: "Increases mission speed",
                G: "pickaxe.webp",
                H: at(.35),
                ar: 1,
                f: "Pickaxes upgrades"
            },
            a5: Oi(h([
                s(1, 30),
                s(4, 30)
            ])),
            bu: 2,
            bc: "Pickaxes"
        }
    }, Ni = function(n) {
        return A2(Pi, Yi, n);
    }, Mi = function(n) {
        return A2(xa, function(r) {
            var e = Ni(r), t = A2(Pi, n.as, r);
            if (t > 0) {
                var u = b(e.aC, {
                    ar: t
                });
                return Xr(u);
            }
            return Or;
        }, Li);
    }, Fi = F2(function(n, r) {
        var e = function(n) {
            var r = A2(Re, Ti, Mi(n));
            return 1 + A3(Ur, La, 0, A2(xa, function(n) {
                return 2 === n.$ ? Xr(n.a) : Or;
            }, r));
        }(n), t = st(r).aC;
        return b(t, {
            H: function() {
                var n = t.H;
                switch(n.$){
                    case 0:
                        return it(A2(si, e, n.a));
                    case 1:
                        return at(A2(si, e, n.a));
                    case 2:
                        return Qi(A2(si, e, n.a));
                    default:
                        return ut(A2(si, e, n.a));
                }
            }()
        });
    }), Ri = F2(function(n, r) {
        return c(r, n) > 0;
    }), Ki = function(n) {
        var r = function(n) {
            return (mi(A2(Re, function(r) {
                return Ua(A2(ci, r, n.al));
            }, oi)) - 4) / 100;
        }(n), e = A2(Ri, 0, r) ? h([
            {
                bq: "Increase the yield of missions",
                G: "engineer.webp",
                H: it(r),
                ar: 1,
                f: "Squad bonus"
            }
        ]) : v, t = Mi(n);
        return Ii(h([
            e,
            A2(Re, function(r) {
                return A2(Fi, n, r.a);
            }, n.S),
            t
        ]));
    }, Ui = function(n) {
        return A2(Re, function(n) {
            return n.H;
        }, Ki(n));
    }, Ji = F2(function(n, r) {
        switch(n){
            case 0:
                return r.dH;
            case 1:
                return r.dI;
            case 2:
                return r.dJ;
            case 3:
                return r.dK;
            default:
                return r.dL;
        }
    }), Vi = F2(function(n, r) {
        return n / r;
    }), Wi = F3(function(n, r, e) {
        var t = A2(La, e.C, A2(Vi, r, n)), u = xe(t);
        return s({
            C: t - xe(t),
            U: !0
        }, u);
    }), Zi = function(n) {
        return A2(Re, Ge, n);
    }, no = {
        $: 10
    }, ro = function(n) {
        return {
            $: 11,
            a: n
        };
    }, eo = {
        $: 5
    }, to = {
        $: 0
    }, uo = {
        $: 1
    }, ao = {
        $: 2
    }, io = {
        $: 3
    }, oo = {
        $: 12
    }, co = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fo = Oi(h([
        s(2, h([
            {
                k: 1,
                m: to,
                f: "Haz 2"
            }
        ])),
        s(3, h([
            {
                k: 1,
                m: uo,
                f: "Haz 3"
            }
        ])),
        s(4, h([
            {
                k: 2,
                m: co(3),
                f: "Retro Theme"
            }
        ])),
        s(5, h([
            {
                k: 1,
                m: ao,
                f: "Haz 4"
            }
        ])),
        s(6, h([
            {
                k: 0,
                m: eo,
                f: "Dwarf Xp Buttons"
            }
        ])),
        s(7, h([
            {
                k: 2,
                m: co(5),
                f: "Theme: Black"
            }
        ])),
        s(8, h([
            {
                k: 1,
                m: Za,
                f: "Dwarf Xp Button 2"
            }
        ])),
        s(9, h([
            {
                k: 1,
                m: io,
                f: "Haz 5"
            }
        ])),
        s(10, h([
            {
                k: 2,
                m: co(6),
                f: "Theme: Luxury"
            }
        ])),
        s(11, h([
            {
                k: 1,
                m: ni,
                f: "Dwarf Xp Button 3"
            }
        ])),
        s(12, h([
            {
                k: 1,
                m: ri,
                f: "Dwarf Xp Button 4"
            }
        ])),
        s(13, h([
            {
                k: 1,
                m: ei,
                f: "Dwarf Xp Button 5"
            }
        ])),
        s(15, h([
            {
                k: 0,
                m: no,
                f: "Abyss Bar"
            }
        ])),
        s(20, h([
            {
                k: 0,
                m: ro(0),
                f: "Biomes"
            },
            {
                k: 0,
                m: oo,
                f: "Projects"
            }
        ])),
        s(23, h([
            {
                k: 2,
                m: co(4),
                f: "Theme: Cyberpunk"
            }
        ])),
        s(25, h([
            {
                k: 3,
                m: ro(1),
                f: "Biomes Tier II"
            }
        ])),
        s(28, h([
            {
                k: 3,
                m: ro(2),
                f: "Biomes Tier III"
            }
        ])),
        s(30, h([
            {
                k: 2,
                m: co(4),
                f: "Theme: Cyberpunk"
            }
        ]))
    ])), so = function(n) {
        return n.b ? Xr(A3(Ur, $e, n.a, n.b)) : Or;
    }, lo = {
        dH: {
            aI: ti(1),
            aQ: 1.5,
            f: "Haz 1",
            a3: Or
        },
        dI: {
            aI: ti(5),
            aQ: 2.5,
            f: "Haz 2",
            a3: Xr(to)
        },
        dJ: {
            aI: ti(30),
            aQ: 4,
            f: "Haz 3",
            a3: Xr(uo)
        },
        dK: {
            aI: Ya(3),
            aQ: 7.75,
            f: "Haz 4",
            a3: Xr(ao)
        },
        dL: {
            aI: Ya(20),
            aQ: 12,
            f: "Haz 5",
            a3: Xr(io)
        }
    }, bo = F2(function(n, r) {
        var e = Gt(r), t = e.aw, u = e.aY, a = A2(Ji, n, lo).aQ;
        return A4(_u, F3(function(n, r, e) {
            return Oi(h(e ? [
                s(u, r * a),
                s(t, n * a)
            ] : [
                s(t, n * a)
            ]));
        }), A2(vi, .5, 1), A2(vi, .25, .75), A2(ku, function(n) {
            return 0 > c(n, .5);
        }, A2(vi, 0, 1)));
    }), vo = function(n) {
        return A3(Ur, La, 0, A2(xa, function(n) {
            return n.$ ? Or : Xr(n.a);
        }, n));
    }, po = F2(function(n, r) {
        return A2(Re, function(r) {
            var e = r.a;
            return s(e, A2(n, e, r.b));
        }, r);
    }), mo = F2(function(n, r) {
        var e = 1 + vo(Ui(n));
        return {
            v: A2(po, F2(function(n, r) {
                return r * e;
            }), r.v),
            aQ: r.aQ * e
        };
    }), ho = Qn("openModal", Ea), go = Qn("saveGame", Le), wo = function(n) {
        return n.D.c8 ? At : Ct(Dt);
    }, xo = F3(function(n, r, e) {
        switch(r){
            case 0:
                return b(e, {
                    dr: n
                });
            case 1:
                return b(e, {
                    ds: n
                });
            case 2:
                return b(e, {
                    dt: n
                });
            case 3:
                return b(e, {
                    du: n
                });
            default:
                return b(e, {
                    dv: n
                });
        }
    }), yo = F3(function(n, r, e) {
        switch(n){
            case 0:
                return b(e, {
                    dH: r
                });
            case 1:
                return b(e, {
                    dI: r
                });
            case 2:
                return b(e, {
                    dJ: r
                });
            case 3:
                return b(e, {
                    dK: r
                });
            default:
                return b(e, {
                    dL: r
                });
        }
    }), $o = F3(function(n, r, e) {
        if (e.$) {
            var t = A3(Wi, r, n, e.a);
            return t.b > 0 ? At : Ct(t.a);
        }
        return e;
    }), ko = F3(function(n, r, e) {
        return A3(xo, n(A2(ai, r, e)), e, r);
    }), jo = F3(function(n, r, e) {
        return A3(yo, n, r(A2(Ji, n, e)), e);
    }), zo = F3(function(n, r, e) {
        switch(r){
            case 0:
                return b(e, {
                    cj: n
                });
            case 1:
                return b(e, {
                    cf: n
                });
            case 2:
                return b(e, {
                    ca: n
                });
            default:
                return b(e, {
                    cu: n
                });
        }
    }), Go = F3(function(n, r, e) {
        return A3(zo, n(A2(Pi, r, e)), e, r);
    }), _o = F2(function(n, r) {
        n: for(;;){
            var e = s(r, Eu);
            switch(n.$){
                case 0:
                    return e;
                case 10:
                    return s(A2(Lu, r.Q, r.a7), Eu);
                case 17:
                    return s(r, ho(n.a));
                case 1:
                    var t = Mt(n.a + xe(1e3 * r.D.c$)), u = (t - r.a7) * r.D.dF * .001, a = A3($o, u, Na, r.aF), i = A2(xa, function(n) {
                        var r = n.a, e = A3(Wi, Oa, u, n.b);
                        return e.b > 0 ? Or : Xr(s(r, e.a));
                    }, r.S), o = F2(function(n, r) {
                        var e = ii(n).aI;
                        return A3(ko, A2($o, u, e), r, n);
                    }), f = F2(function(n, e) {
                        var t = A2(Pa, A2(Ji, n, lo).aI, Ui(r));
                        return A3(jo, n, A2($o, u, t), e);
                    }), l = A3(Wi, 1, u, r.bA), d = l.a, v = 1 > l.b ? Or : Xr(go(Di(r)));
                    return s(b(r, {
                        S: i,
                        a7: t,
                        aF: a,
                        _: A3(Ur, o, r._, Ia),
                        ad: A3(Ur, f, r.ad, Qa),
                        bA: d
                    }), Pu(A2(xa, Le, h([
                        v
                    ]))));
                case 2:
                    var p = n.a, m = A2(Ji, p, lo), g = A3(yo, p, wo(r), r.ad), w = (L = r.ac).$ ? s(xi, r.Q) : A2(Cu, A2(bo, p, L.a), r.Q), x = w.b, y = A2(mo, r, {
                        v: w.a,
                        aQ: m.aQ
                    }), $ = A2(Ha, y.aQ, r);
                    return s(b(r, {
                        h: $.h,
                        v: A2(Aa, r.v, y.v),
                        ad: g,
                        aQ: $.aQ,
                        Q: x
                    }), Eu);
                case 12:
                    var k = n.a, j = (m = ii(k), A3(xo, wo(r), k, r._)), z = A2(Cu, A3(wi, m.bI, r.al, Ui(r)), r.Q), G = z.a, _ = G.a, C = G.b, A = z.b;
                    return Ua(A2(ci, _, r.al)), Ua(A2(ci, _, C)), s(b(r, {
                        al: C,
                        _: j,
                        Q: A
                    }), Eu);
                case 3:
                    return s(b(r, {
                        bG: Xr(n.a)
                    }), Eu);
                case 4:
                    return s(b(r, {
                        D: b(B = r.D, {
                            dF: n.a
                        })
                    }), Eu);
                case 5:
                    return s(b(r, {
                        D: b(B = r.D, {
                            c$: A2(La, B.c$, n.a)
                        })
                    }), Eu);
                case 6:
                    var B;
                    return s(b(r, {
                        D: b(B = r.D, {
                            c8: n.a
                        })
                    }), Eu);
                case 7:
                    return s(b(r, {
                        h: r.h + 1
                    }), Eu);
                case 8:
                    return so(Zi(fo)), s(b(r, {
                        h: Wa
                    }), Eu);
                case 11:
                    return s(b(r, {
                        a6: n.a
                    }), Eu);
                case 13:
                    var S = n.a, D = A2(Cu, Tu, r.Q), H = D.a;
                    return x = D.b, s(b(r, {
                        S: A2(Cr, s(S, Dt), r.S),
                        aF: Ct(Dt),
                        bo: H,
                        Q: x
                    }), Eu);
                case 14:
                    return s(b(r, {
                        ac: Xr(n.a)
                    }), qa("popover-1"));
                case 15:
                    return s(b(r, {
                        ac: Or
                    }), qa("popover-1"));
                case 16:
                    var I = n.a, Q = (m = Ni(I), c(A2(Pi, r.as, I), m.bu) > -1), T = !Q && A3(za, F3(function(n, e, t) {
                        return t && c(A2(Ga, r.v, n), e) > -1;
                    }), !0, m.a5);
                    return s(function() {
                        if (T && !Q) {
                            var n = A3(Go, function(n) {
                                return n + 1;
                            }, r.as, I);
                            return b(r, {
                                v: A3(za, F3(function(n, r, e) {
                                    return A3(Ca, function(n) {
                                        return n - r;
                                    }, e, n);
                                }), r.v, m.a5),
                                as: n
                            });
                        }
                        return r;
                    }(), Eu);
                case 18:
                    switch(n.a){
                        case "ArrowUp":
                            return s(b(r, {
                                h: r.h + 1
                            }), Eu);
                        case "ArrowDown":
                            return s(b(r, {
                                h: Wa
                            }), Eu);
                        case "ArrowRight":
                            n = {
                                $: 5,
                                a: Ya(1)
                            };
                            continue n;
                        default:
                            return s(r, Eu);
                    }
                default:
                    return s(b(r, {
                        v: yu(100)
                    }), Eu);
            }
        }
        var L;
    }), Co = {
        $: 10
    }, Ao = On("aside"), Bo = F2(function(n, r) {
        return A2(Kn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), Un(r));
    }), So = On("button"), Do = F2(function(n, r) {
        return A2(Rn, n, Ea(r));
    }), Ho = Do("className"), Io = function(n) {
        return Ho(A2(Fr, " ", A2(Re, Ge, A2(Ei, Bu, n))));
    }, Qo = On("div"), To = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (n(r.a)) return !0;
            r = e;
        }
    }), Lo = F3(function(n, r, e) {
        return r(n(e));
    }), Po = F2(function(n, r) {
        return A2(To, function(e) {
            var t = e.a, u = e.b;
            return A2(To, A2(Lo, function(n) {
                return n.m;
            }, we(r)), u) && 1 > c(t, n);
        }, fo);
    }), Eo = function(n) {
        return A2(Po, n, eo);
    }, qo = Do("htmlFor"), Xo = On("form"), Oo = On("h3"), Yo = Do("id"), No = On("input"), Mo = On("label"), Fo = On("li"), Ro = Do("method"), Ko = function(n) {
        return On(function(n) {
            return "script" == n ? "p" : n;
        }(n));
    }, Uo = Mn, Jo = F2(function(n, r) {
        return A2(Uo, n, {
            $: 0,
            a: r
        });
    }), Vo = function(n) {
        return A2(Jo, "click", Qe(n));
    }, Wo = On("p"), Zo = F2(function(n, r) {
        return 0 > c(n, r) ? n : r;
    }), nc = F2(function(n, r) {
        return n - r;
    }), rc = F2(function(n, r) {
        return r * n;
    }), ec = F2(function(n, r) {
        var e = A2(nc, 1, A2(Zo, 100, r.C));
        return A2(rc, e, n);
    }), tc = On("h1"), uc = On("h2"), ac = F2(function(n, r) {
        return 0 > c(r, n);
    }), ic = F2(function(n, r) {
        return A2(ac, .05, A2(rc, r.C, n));
    }), oc = On("img"), cc = function(n) {
        return n / 3600;
    }, fc = function(n) {
        return n / 60;
    }, sc = function(n) {
        return !n.b;
    }, lc = ti(1), bc = j, dc = F2(function(n, r) {
        return 1 > n ? r : A3(Ee, 0, -n, r);
    }), vc = L, pc = S, mc = function(n) {
        return A3(pc, Cr, v, n);
    }, hc = F2(function(n, r) {
        var e = A2(To, function(n) {
            return "0" !== n && "." !== n;
        }, mc(r));
        return d(n && e ? "-" : "", r);
    }), gc = P, wc = B, xc = function(n) {
        var r = n.a, e = n.b;
        if ("9" === r) {
            var t = ie(e);
            return 1 === t.$ ? "01" : A2(wc, "0", xc(t.a));
        }
        var u, a = re(r);
        return a >= 48 && 57 > a ? A2(wc, 0 > (u = a + 1) || u > 1114111 ? "\uFFFD" : u > 65535 ? String.fromCharCode(Math.floor((u -= 65536) / 1024) + 55296, u % 1024 + 56320) : String.fromCharCode(u), e) : "0";
    }, yc = function(n) {
        return n === 1 / 0 || n === -1 / 0;
    }, $c = A, kc = function(n) {
        return A2(wc, n, "");
    }, jc = F3(function(n, r, e) {
        return n > 0 ? A3(jc, n >> 1, d(r, r), 1 & n ? d(e, r) : e) : e;
    }), zc = F2(function(n, r) {
        return A3(jc, n, r, "");
    }), Gc = F3(function(n, r, e) {
        return d(e, A2(zc, n - Pe(e), kc(r)));
    }), _c = function(n) {
        for(var r = n.length, e = Array(r), t = 0; r > t;){
            var u = n.charCodeAt(t);
            55296 > u || u > 56319 ? (e[r - t] = n[t], t++) : (e[r - t] = n[t + 1], e[r - ++t] = n[t - 1], t++);
        }
        return e.join("");
    }, Cc = function(n) {
        var r = A2(Rr, ".", n);
        return r.b ? s(r.a, r.b.b ? r.b.a : "0") : s("0", "0");
    }, Ac = F2(function(n, r) {
        var e = r.b;
        return s(n(r.a), e);
    }), Bc = F3(function(n, r, e) {
        if (yc(e) || $c(e)) return gc(e);
        var t = 0 > e, u = Cc(function(n) {
            var r = A2(Rr, "e", gc(di(n)));
            if (r.b) {
                if (r.b.b) {
                    var e = r.a, t = r.b.a, u = A2(Va, 0, function(n) {
                        for(var r = 0, e = n.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, u = t; n.length > u; ++u){
                            var a = n.charCodeAt(u);
                            if (48 > a || a > 57) return Or;
                            r = 10 * r + a - 48;
                        }
                        return u == t ? Or : Xr(45 == e ? -r : r);
                    }(A2(Xe, "+", t) ? A2(qe, 1, t) : t)), a = Cc(e), i = d(a.a, a.b), o = 0 > u ? A2(Va, "0", A2(Ja, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Ja, Ac(kc), ie(d(A2(zc, di(u), "0"), i))))) : A3(Gc, u + 1, "0", i);
                    return d(0 > n ? "-" : "", o);
                }
                return d(0 > n ? "-" : "", e = r.a);
            }
            return "";
        }(di(e))), a = u.a, i = u.b, o = Pe(a) + r, f = d(A2(zc, 1 - o, "0"), A3(Gc, o, "0", d(a, i))), s = Pe(f), l = A2($e, 1, o), b = A2(n, t, A3(Ee, l, s, f)), v = A3(Ee, 0, l, f), p = b ? _c(A2(Va, "1", A2(Ja, xc, ie(_c(v))))) : v, m = Pe(p), h = "0" === p ? p : r > 0 ? 0 > c(r, Pe(i)) ? A3(Ee, 0, m - r, p) + "." + A3(Ee, m - r, m, p) : d(a + ".", A3(Gc, r, "0", i)) : d(p, A2(zc, di(r), "0"));
        return A2(hc, t, h);
    })(F2(function(n, r) {
        var e, t = ie(r);
        return 1 !== t.$ && ("5" === t.a.a ? "" !== t.a.b || !n : (e = re(t.a.a)) > 53 && n || e >= 53 && !n);
    })), Sc = function(n) {
        return 100 * n;
    }, Dc = function(n) {
        var r = A2(Bc, 2, Sc(n));
        return A2(vc, ".00", r) ? A2(dc, 3, r) : A2(vc, ".0", r) ? A2(dc, 2, r) : r;
    }, Hc = function(n) {
        switch(n.$){
            case 0:
                return "+" + Dc(n.a) + "% yield";
            case 1:
                return "+" + Dc(n.a) + "% speed";
            case 2:
                return "+" + Dc(n.a) + "% buff strength";
            default:
                return "+" + Dc(n.a) + "% xp gain";
        }
    }, Ic = F3(function(n, r, e) {
        return d(A2(zc, n - Pe(e), kc(r)), e);
    }), Qc = Ho("prose"), Tc = function(n) {
        return A2(Do, "src", Un(n));
    }, Lc = qn, Pc = function(n) {
        var r = n.f, e = n.G, t = n.H;
        return A2(Qo, h([
            Ho("flex flex-col items-center border border-content rounded-sm p-1 bg-info text-info-content")
        ]), h([
            A2(Qo, h([
                Ho("flex items-center gap-1")
            ]), h([
                A2(oc, h([
                    Tc(e),
                    Ho("w-4")
                ]), v),
                A2(Qo, h([
                    Ho("text-sm leading-none")
                ]), h([
                    Lc(r)
                ]))
            ])),
            A2(Qo, v, h([
                Lc(Hc(t))
            ]))
        ]));
    }, Ec = Do("alt"), qc = On("figure"), Xc = On("span"), Oc = F2(function(n, r) {
        var e, t = st(r), u = A2(Fi, n, r);
        return A2(Qo, h([
            Ho("card card-sm bg-base-300 w-72 shadow-lg")
        ]), h([
            A2(qc, h([
                Ho("pt-2 bg-warning")
            ]), h([
                A2(oc, h([
                    Tc(t.G),
                    Ec(t.f)
                ]), v),
                A2(oc, h([
                    Tc("beer/beer.png"),
                    Ho("w-24 -ml-6")
                ]), v)
            ])),
            A2(Qo, h([
                Ho("card-body")
            ]), h([
                A2(uc, h([
                    Ho("card-title")
                ]), h([
                    Lc("Daily Special: "),
                    A2(Xc, h([
                        Ho("underline")
                    ]), h([
                        Lc(t.f)
                    ]))
                ])),
                A2(Wo, v, h([
                    Lc(Hc(u.H))
                ])),
                A2(Qo, h([
                    Ho("card-actions justify-end")
                ]), h([
                    A2(So, h([
                        Ho("btn btn-warning"),
                        Vo((e = r, {
                            $: 13,
                            a: e
                        }))
                    ]), h([
                        Lc("Select")
                    ]))
                ]))
            ]))
        ]));
    }), Yc = F2(function(n, r) {
        var e = Qo(h([
            Ho("flex w-full gap-3 text-center justify-end")
        ])), t = A2(Ri, lc, n), u = F2(function(n, r) {
            return A2(Qo, h([
                Ho("flex flex-col")
            ]), h([
                A2(Xc, h([
                    Ho("countdown font-mono text-2xl")
                ]), h([
                    A2(Xc, h([
                        A2(Bo, "style", "--value:" + Mr(n))
                    ]), v)
                ])),
                Lc(r)
            ]));
        }), a = Qo(h([
            Ho("invisible")
        ])), i = r && t ? A2(La, n, 1) : n, o = xe(cc(i)), c = A2(bc, 60, xe(fc(i))), f = !t && r ? 60 : A2(bc, 60, xe(i));
        return e(h(o > 0 ? [
            A2(u, o, "hours"),
            A2(u, c, "min"),
            A2(u, f, "sec")
        ] : c > 0 ? [
            a(h([
                A2(u, o, "hours")
            ])),
            A2(u, c, "min"),
            A2(u, f, "sec")
        ] : [
            a(h([
                A2(u, o, "hours")
            ])),
            a(h([
                A2(u, c, "min")
            ])),
            A2(u, f, "sec")
        ]));
    }), Nc = On("strong"), Mc = {
        aB: Ho("w-full flex items-center justify-center gap-4 px-8 h-14"),
        aj: Ho("flex flex-col items-center grow overflow-scroll"),
        ak: Ho("pt-0 w-full flex justify-center px-8"),
        ao: Ho("px-8 py-4 w-full flex items-center justify-center")
    }, Fc = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Rc = F2(function(n, r) {
        var e = ii(r).a3;
        return 1 === e.$ || A2(Po, n, e.a);
    }), Kc = {
        bz: !0,
        bD: !1
    }, Uc = F2(function(n, r) {
        return A2(Uo, n, {
            $: 3,
            a: r
        });
    }), Jc = F5(function(n, r, e, t, u) {
        return {
            dg: u,
            dT: t,
            ej: r,
            ek: e,
            el: n
        };
    }), Vc = A6(Jt, F5(function(n, r, e, t, u) {
        return {
            b2: r,
            em: e,
            eD: t,
            eE: u,
            cV: n
        };
    }), A2(et, "width", ht), A2(et, "height", ht), A2(et, "pressure", ht), A2(et, "tiltX", ht), A2(et, "tiltY", ht)), Wc = F6(function(n, r, e, t, u, a) {
        return {
            c7: r,
            de: e,
            dV: n,
            ed: t,
            ei: u,
            eu: a
        };
    }), Zc = A2(He, function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            default:
                return 0;
        }
    }, A2(et, "button", Qt)), nf = A3(Ie, F2(function(n, r) {
        return s(n, r);
    }), A2(et, "clientX", ht), A2(et, "clientY", ht)), rf = A7(Lt, Wc, A5(Wt, F4(function(n, r, e, t) {
        return {
            c0: n,
            dj: r,
            d_: e,
            ew: t
        };
    }), A2(et, "altKey", xt), A2(et, "ctrlKey", xt), A2(et, "metaKey", xt), A2(et, "shiftKey", xt)), Zc, nf, A3(Ie, F2(function(n, r) {
        return s(n, r);
    }), A2(et, "offsetX", ht), A2(et, "offsetY", ht)), A3(Ie, F2(function(n, r) {
        return s(n, r);
    }), A2(et, "pageX", ht), A2(et, "pageY", ht)), A3(Ie, F2(function(n, r) {
        return s(n, r);
    }), A2(et, "screenX", ht), A2(et, "screenY", ht))), ef = A6(Jt, Jc, A2(et, "pointerType", A2(He, function(n) {
        switch(n){
            case "pen":
                return 2;
            case "touch":
                return 1;
            default:
                return 0;
        }
    }, dt)), rf, A2(et, "pointerId", Qt), A2(et, "isPrimary", xt), Vc), tf = A2(F3(function(n, r, e) {
        return A2(Uc, n, A2(He, function(n) {
            return {
                W: e(n),
                bz: r.bz,
                bD: r.bD
            };
        }, ef));
    }), "pointerup", Kc), uf = F6(function(n, r, e, t, u, a) {
        if (r.$) {
            var i = r.a, o = A2(ic, e, i), c = A2(ec, e, i);
            return A2(Qo, h([
                Ho("flex items-end gap-8 w-full h-full")
            ]), h([
                A2(Yc, c, o)
            ]));
        }
        var f = Ho(u ? "btn-secondary" : "btn-primary");
        return A2(Qo, h([
            Ho("flex items-center justify-end gap-8 w-full")
        ]), h([
            A2(Qo, h([
                Ho("relative inline-block")
            ]), h([
                A2(So, h([
                    Ho("btn"),
                    f,
                    tf(t)
                ]), a)
            ]))
        ]));
    }), af = function(n) {
        return Mr(xe(n));
    }, of = On("a"), cf = F2(function(n, r) {
        switch(r){
            case 0:
            default:
                return !0;
            case 1:
                return Eo(n.h);
            case 2:
                return A2(Po, n.h, oo);
            case 3:
                return A2(Po, n.h, no);
        }
    }), ff = Kn("class"), sf = Kn("fill"), lf = Kn("height"), bf = Nn, df = Kn("stroke"), vf = Kn("stroke-linecap"), pf = Kn("stroke-linejoin"), mf = Kn("stroke-width"), hf = tu("svg"), gf = Kn("viewBox"), wf = Kn("width"), xf = F2(function(n, r) {
        var e, t = r.b, u = r.y, a = gc(u.ag), i = h([
            sf("none"),
            lf(d(a, u.aZ)),
            wf(d(a, u.aZ)),
            df("currentColor"),
            vf("round"),
            pf("round"),
            mf(gc(u.bk)),
            gf(u.bn)
        ]), o = d((e = u.a4).$ ? i : A2(Cr, ff(e.a), i), n);
        return A2(hf, o, A2(Re, bf(Oe), t));
    }), yf = F2(function(n, r) {
        var e = r.b;
        return {
            y: b(r.y, {
                ag: n
            }),
            b: e
        };
    }), $f = F2(function(n, r) {
        var e, t, u = A2(eu, r, du), i = a(n.a6, r);
        return A2(Fo, h([
            Io(h([
                s("hidden", !A2(cf, n, r))
            ]))
        ]), h([
            A2(of, h([
                Vo((t = r, {
                    $: 11,
                    a: t
                })),
                Io(h([
                    s("menu-active", i)
                ]))
            ]), Ii(h([
                (e = u.aP, e.$ ? v : h([
                    A2(xf, v, A2(yf, 16, e.a))
                ])),
                h([
                    A2(Xc, v, h([
                        Lc(u.f)
                    ]))
                ])
            ])))
        ]));
    }), kf = {
        dq: {
            ba: "driller.webp",
            bc: "Driller"
        },
        dx: {
            ba: "engineer.webp",
            bc: "Engineer"
        },
        dG: {
            ba: "gunner.webp",
            bc: "Gunner"
        },
        et: {
            ba: "scout.webp",
            bc: "Scout"
        }
    }, jf = function(n) {
        return A2(Fe, F2(function(r, e) {
            return n(r) && sc(e) ? v : A2(Cr, r, e);
        }), v);
    }, zf = function(n) {
        var r, e = Ua(n);
        return A2(nc, n, (r = e, A3(Ur, F2(function(n, r) {
            return A2(La, r, It(n.b));
        }), It(0), A2(jf, function(n) {
            return c(n.a, r) > -1;
        }, Ka))));
    }, Gf = function(n) {
        return g(n).join("");
    }, _f = k, Cf = _, Af = F2(function(n, r) {
        if (0 > n) return r;
        var e = A2(_f, 10, n), t = ke(e);
        return Cf(t(r)) / e;
    }), Bf = F2(function(n, r) {
        return 0 > n ? r : A2(Af, n, r);
    }), Sf = F2(function(n, r) {
        return $c(r) ? "NaN" : yc(r) ? (0 > r ? "-" : "") + "Infinity" : n > 0 ? function(r) {
            var e = A2(Rr, ".", r);
            n: for(;;){
                if (e.b) {
                    if (e.b.b) {
                        if (e.b.b.b) break n;
                        return e.a + "." + A3(Gc, n, "0", e.b.a);
                    }
                    return e.a + "." + A2(zc, n, "0");
                }
                break n;
            }
            return r;
        }(gc(A2(Af, n, r))) : gc(A2(Bf, n, r));
    }), Df = function(n) {
        return Gf(A2(jf, we("."), A2(jf, we("0"), mc(A2(Sf, 2, n)))));
    }, Hf = Fn, If = F2(function(n, r) {
        var e = A2(ci, r, n.al), t = zf(e), u = A2(ci, r, kf), a = function(n) {
            var r = zf(n), e = Ua(n), t = Ra(e);
            return t.$ || t.a.$ ? 1 : r / t.a.a;
        }(e), i = Ua(e), o = function() {
            var n = Ra(i);
            if (n.$ || n.a.$) return A2(Xc, h([
                Ho("text-xs")
            ]), h([
                Lc("Max level reached")
            ]));
            var r = n.a.a;
            return A2(Xc, h([
                Ho("text-xs")
            ]), h([
                Lc(Df(t) + " / " + Df(r) + " xp to next level")
            ]));
        }(), c = u.ba;
        return A2(Qo, h([
            Ho("bg-base-300 text-base-content flex flex-col items-center relative overflow-hidden themed-rounded-borders shadow-sm")
        ]), h([
            A2(Xc, h([
                Ho("w-full flex items-center justify-center gap-2")
            ]), h([
                A2(Xc, h([
                    Ho("text-lg")
                ]), h([
                    Lc(u.bc)
                ]))
            ])),
            A2(oc, h([
                Tc(c),
                Ho("h-12 rounded-sm ")
            ]), v),
            A2(Xc, v, h([
                o
            ])),
            A2(Qo, h([
                Ho("tooltip tooltip-left absolute top-0 right-0"),
                A2(Bo, "data-tip", "Level " + Mr(i))
            ]), h([
                A2(Xc, h([
                    Ho("inline-block bg-secondary text-secondary-content px-3 py-1 text-2xl border border-secondary-content themed-rounded-borders")
                ]), h([
                    Lc(Mr(i))
                ]))
            ])),
            A2(Qo, h([
                Ho("w-full h-2 relative bg-secondary/15")
            ]), h([
                A2(Qo, h([
                    Ho("absolute left-0 top-0 h-full bg-secondary xp-bar themed-rounded-borders"),
                    A2(Hf, "width", gc(A2(Zo, 100, Sc(a))) + "%")
                ]), v)
            ]))
        ]));
    }), Qf = {
        $: 7
    }, Tf = {
        $: 9
    }, Lf = {
        $: 8
    }, Pf = h([
        0,
        1,
        2,
        3,
        4,
        5
    ]), Ef = Kn("points"), qf = tu("polyline"), Xf = A2(fu, "chevron-up", h([
        A2(qf, h([
            Ef("18 15 12 9 6 15")
        ]), v)
    ])), Of = A2(fu, "chevrons-up", h([
        A2(qf, h([
            Ef("17 11 12 6 7 11")
        ]), v),
        A2(qf, h([
            Ef("17 18 12 13 7 18")
        ]), v)
    ])), Yf = {
        c4: {
            G: "minerals/bismor.webp",
            bc: "Bismor"
        },
        di: {
            G: "minerals/croppa.webp",
            bc: "Croppa"
        },
        dy: {
            G: "minerals/enorPearl.webp",
            bc: "Enor Pearl"
        },
        dU: {
            G: "minerals/jadiz.webp",
            bc: "Jadiz"
        },
        dY: {
            G: "minerals/magnite.webp",
            bc: "Magnite"
        },
        eH: {
            G: "minerals/umanite.webp",
            bc: "Umanite"
        }
    }, Nf = function(n) {
        return A2(Ga, Yf, n);
    }, Mf = F2(function(n, r) {
        return r.$ ? Or : n(r.a);
    }), Ff = F2(function(n, r) {
        for(;;){
            if (!r.b) return Or;
            var e = r.a, t = e.b, u = r.b;
            if (a(e.a, n)) return Xr(t);
            r = u;
        }
    }), Rf = function(n) {
        return n.b ? Xr(n.a) : Or;
    }, Kf = F2(function(n, r) {
        var e;
        return A2(Mf, function(n) {
            return A2(Ja, function(r) {
                return s(n, r);
            }, A2(Mf, Rf, A2(Ff, n, r)));
        }, Rf((e = A2(Ei, function(r) {
            return c(r, n) > 0;
        }, Zi(r)), A2(Su, Le, e))));
    }), Uf = tu("line"), Jf = Kn("x1"), Vf = Kn("x2"), Wf = Kn("y1"), Zf = Kn("y2"), ns = A2(fu, "package", h([
        A2(Uf, h([
            Jf("16.5"),
            Wf("9.4"),
            Vf("7.5"),
            Zf("4.21")
        ]), v),
        A2(su, h([
            ou("M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z")
        ]), v),
        A2(qf, h([
            Ef("3.27 6.96 12 12.01 20.73 6.96")
        ]), v),
        A2(Uf, h([
            Jf("12"),
            Wf("22.08"),
            Vf("12"),
            Zf("12")
        ]), v)
    ])), rs = F3(function(n, r, e) {
        var t = function() {
            switch(e.k){
                case 0:
                    return "Feature";
                case 1:
                    return "Activity";
                case 2:
                    return "Cosmetic";
                default:
                    return "Biomes";
            }
        }();
        return A2(Qo, h([
            Ho("flex-col items-start text-lg")
        ]), h([
            A2(Xc, v, h([
                Lc("Unlock new "),
                A2(Nc, h([
                    Ho("text-primary")
                ]), h([
                    Lc(t)
                ])),
                A2(Xc, v, h([
                    Lc(" at level " + Mr(r))
                ]))
            ]))
        ]));
    }), es = A2(oc, h([
        Tc("minerals/morkite.webp"),
        Ho("w-6 inline-block")
    ]), v), ts = function(n) {
        var r = Ho("px-3 py-1 rounded-sm bg-base-100 text-base-content text-3xl leading-none text-xl opacity-75"), e = Ho("w-full h-12 border border-neutral relative flex items-center justify-center gap-1 overflow-hidden themed-rounded-borders"), t = function(n) {
            return A2(Qo, h([
                Ho("absolute left-0 top-0 h-full bg-primary themed-rounded-borders"),
                Io(h([
                    s("border-r", 1 !== n && 0 !== n)
                ])),
                A2(Hf, "width", gc(A2(Zo, 100, Sc(n))) + "%"),
                Yo("xp-bar")
            ]), v);
        }, u = Da(n.h);
        if (1 === u.$) return A2(Qo, h([
            e
        ]), h([
            A2(Xc, h([
                Ho("z-10 uppercase"),
                r
            ]), h([
                Lc("max level reached")
            ])),
            t(1)
        ]));
        var a = u.a, i = n.aQ / a;
        return A2(Qo, h([
            e
        ]), h([
            A2(Xc, h([
                Ho("z-10 relative flex items-center gap-2"),
                r
            ]), h([
                A2(Xc, h([
                    Ho("font-semibold text-3xl leading-none font-mono mr-2")
                ]), h([
                    Lc(Df(n.aQ) + " / " + Df(a))
                ])),
                Lc("morkite"),
                A2(Xc, h([
                    Ho("flex items-center")
                ]), h([
                    es
                ])),
                Lc("to next level")
            ])),
            t(i)
        ]));
    }, us = function(n) {
        var r;
        return A2(Qo, h([
            Ho("w-full min-w-full bg-base-200 flex items-center justify-center p-4")
        ]), h([
            A2(Qo, h([
                Ho("flex items-end gap-4 w-full")
            ]), h([
                A2(Qo, h([
                    Ho("flex flex-col items-center")
                ]), h([
                    A2(Mo, h([
                        Ho("text-sm")
                    ]), h([
                        Lc("level")
                    ])),
                    A2(Qo, h([
                        Ho("w-full flex justify-center items-center relative min-w-12")
                    ]), h([
                        A2(Qo, h([
                            Ho("text-6xl leading-none font-extrabold relative inline-block z-10")
                        ]), h([
                            Lc(A3(Ic, 2, "0", Mr(n.h))),
                            A2(So, h([
                                Ho("absolute top-0 right-0 -mr-8 opacity-25 mt-1/2 btn btn-xs btn-square btn-ghost"),
                                Io(h([
                                    s("hidden", !1)
                                ])),
                                Vo(Lf)
                            ]), h([
                                A2(xf, v, A2(yf, 20, Of))
                            ])),
                            A2(So, h([
                                Ho("absolute top-0 right-0 -mr-8 mt-6 opacity-25 mt-1/2 btn btn-xs btn-square btn-ghost"),
                                Io(h([
                                    s("hidden", !1)
                                ])),
                                Vo(Qf)
                            ]), h([
                                A2(xf, v, A2(yf, 20, Xf))
                            ]))
                        ]))
                    ]))
                ])),
                A2(Qo, h([
                    Ho("pb-1 w-full h-full flex flex-col items-end relative")
                ]), h([
                    function() {
                        var r = A2(Kf, n.h, fo);
                        if (1 === r.$) return A2(Qo, v, v);
                        var e = r.a;
                        return A3(rs, n, e.a, e.b);
                    }(),
                    ts(n)
                ])),
                A2(Qo, h([
                    Ho("grid grid-cols-2 grid-rows-3 gap-2 min-w-64"),
                    Io(h([
                        s("hidden", (r = n.h, !A2(Po, r, ro(0))))
                    ]))
                ]), Ii(h([
                    A2(Re, function(r) {
                        var e = Nf(r), t = A2(Ga, n.v, r);
                        return A2(Qo, h([
                            Ho("flex items-center w-full")
                        ]), h([
                            A2(oc, h([
                                Tc(e.G),
                                Ho("w-4 mr-1")
                            ]), v),
                            A2(Xc, h([
                                Ho("text-xs inline-block w-full")
                            ]), h([
                                Lc(e.bc)
                            ])),
                            A2(Xc, h([
                                Ho("text-xs font-mono")
                            ]), h([
                                Lc(Df(t))
                            ]))
                        ]));
                    }, Pf),
                    h([
                        A2(So, h([
                            Ho("opacity-25 btn btn-xs btn-square btn-ghost"),
                            Io(h([
                                s("hidden", !1)
                            ])),
                            Vo(Tf)
                        ]), h([
                            A2(xf, v, A2(yf, 20, ns))
                        ]))
                    ])
                ])))
            ]))
        ]));
    }, as = A2(Qo, h([
        Ho("flex-1 flex items-center justify-between gap-2 px-4")
    ]), h([
        A2(Qo, h([
            Ho("flex-0 px-2 flex flex-col items-center")
        ]), h([
            A2(Qo, h([
                Ho("font-title text-primary inline-flex text-lg transition-all duration-200 md:text-3xl flex gap-1 items-center rounded-t-xl overflow-hidden p-1 border border-primary border-b-4")
            ]), h([
                A2(Xc, h([
                    Ho("uppercase text-primary font-extrabold leading-none px-1")
                ]), h([
                    Lc("DRG")
                ])),
                A2(Qo, h([
                    Ho("text-primary text-xs font-bold t-column gap-0 leading-2xs text-primary font-mono")
                ]), h([
                    Lc("Mission Control")
                ]))
            ]))
        ]))
    ])), is = A2(fu, "chevron-down", h([
        A2(qf, h([
            Ef("6 9 12 15 18 9")
        ]), v)
    ])), os = F2(function(n, r) {
        var e = A2(Ji, r, lo).a3;
        return 1 === e.$ || A2(Po, n, e.a);
    }), cs = {
        $: 15
    }, fs = A2(fu, "info", h([
        A2(uu, h([
            au("12"),
            iu("12"),
            lu("10")
        ]), v),
        A2(Uf, h([
            Jf("12"),
            Wf("16"),
            Vf("12"),
            Zf("12")
        ]), v),
        A2(Uf, h([
            Jf("12"),
            Wf("8"),
            Vf("12.01"),
            Zf("8")
        ]), v)
    ])), ss = On("ul"), ls = F2(function(n, r) {
        var e = Gt(r).K;
        return A2(Po, n, ro(e));
    }), bs = function(n) {
        return A2(Ei, ls(n), kt);
    }, ds = function(n) {
        return A2(ss, h([
            Ho("menu menu-lg w-124 rounded-box bg-base-100 shadow-sm")
        ]), Ii(h([
            h([
                A2(Fo, h([
                    Ho("menu-title")
                ]), h([
                    A2(Qo, h([
                        Ho("flex flex-col")
                    ]), h([
                        Lc("Select a biome"),
                        A2(Qo, h([
                            Ho("text-xs flex items-center gap-1")
                        ]), h([
                            A2(xf, v, A2(yf, 16, fs)),
                            A2(Qo, v, h([
                                Lc("Biomes contain an abundant and a scarce mineral")
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            A2(Re, function(n) {
                var r, e = Gt(n);
                return A2(Fo, h([
                    Ho("flex flex-col")
                ]), h([
                    A2(of, h([
                        Vo((r = n, {
                            $: 14,
                            a: r
                        }))
                    ]), h([
                        A2(oc, h([
                            Tc(e.G),
                            Ho("w-6")
                        ]), v),
                        Lc(e.bc),
                        A2(Qo, h([
                            Ho("flex items-center gap-1 ml-2")
                        ]), h([
                            A2(Qo, h([
                                Ho("flex items-center")
                            ]), h([
                                A2(oc, h([
                                    Tc(Nf(e.aw).G),
                                    Ho("w-4 h-4")
                                ]), v),
                                A2(Xc, h([
                                    Ho("text-xs ml-1")
                                ]), h([
                                    Lc(Nf(e.aw).bc)
                                ]))
                            ])),
                            A2(Qo, h([
                                Ho("flex items-center")
                            ]), h([
                                A2(oc, h([
                                    Tc(Nf(e.aY).G),
                                    Ho("w-4 h-4 opacity-50")
                                ]), v),
                                A2(Xc, h([
                                    Ho("text-xs ml-1 opacity-50")
                                ]), h([
                                    Lc(Nf(e.aY).bc)
                                ]))
                            ]))
                        ]))
                    ]))
                ]));
            }, bs(n.h)),
            h([
                A2(Fo, h([
                    Ho("mt-2")
                ]), h([
                    A2(So, h([
                        Ho("btn btn-sm w-full"),
                        Vo(cs)
                    ]), h([
                        Lc("Clear selection")
                    ]))
                ]))
            ])
        ])));
    }, vs = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ps = F2(function(n, r) {
        return Gf(mc(A2(Sf, r, n)));
    }), ms = On("td"), hs = On("tr"), gs = F2(function(n, r) {
        var e = A2(Ji, r, lo), t = A2(Ji, r, n.ad), u = function(n) {
            return A2(oc, h([
                Tc(n),
                Ho("w-4 inline")
            ]), v);
        }, i = function() {
            switch(r){
                case 0:
                    return A2(Qo, h([
                        Ho("flex items-center")
                    ]), h([
                        u("haz1.png")
                    ]));
                case 1:
                    return A2(Qo, h([
                        Ho("flex items-center space-x-[-8px]")
                    ]), h([
                        u("haz1.png"),
                        u("haz2.png")
                    ]));
                case 2:
                    return A2(Qo, h([
                        Ho("flex items-center space-x-[-8px]")
                    ]), h([
                        u("haz1.png"),
                        u("haz2.png"),
                        u("haz3.png")
                    ]));
                case 3:
                    return A2(Qo, h([
                        Ho("flex items-center space-x-[-8px]")
                    ]), h([
                        u("haz1.png"),
                        u("haz2.png"),
                        u("haz3.png"),
                        u("haz4.png")
                    ]));
                default:
                    return A2(Qo, h([
                        Ho("flex items-center space-x-[-8px]")
                    ]), h([
                        u("haz1.png"),
                        u("haz2.png"),
                        u("haz3.png"),
                        u("haz4.png"),
                        u("haz5.png")
                    ]));
            }
        }(), o = F3(function(r, t, u) {
            var a = 1 + vo(Ui(n)), i = e.aQ * t, o = Cf(i * a), c = e.aQ * u, f = Cf(c * a), l = Mr(o) + "-" + Mr(f), b = Cf((i + c) / 2 * a);
            return s(l, Mr(b));
        }), c = t.$ ? "On cooldown" : "Ready", f = A2(mo, n, {
            v: xi,
            aQ: e.aQ
        }), l = e.aQ > 0 ? 100 * (f.aQ / e.aQ - 1) : 0, b = l > 0 ? A2(Xc, h([
            Ho("text-xs text-success ml-1")
        ]), h([
            Lc("+" + gc(Cf(l)) + "%")
        ])) : Lc(""), d = l > 0 ? A2(ps, f.aQ, 1) + " morkite" : A2(ps, e.aQ, 1) + " morkite", p = A2(Pa, e.aI, Ui(n));
        return A2(hs, v, h([
            A2(ms, h([
                Ho("h-[70px]")
            ]), h([
                A2(Qo, h([
                    Ho("flex h-full items-center gap-2")
                ]), Ii(h([
                    h([
                        A2(Xc, v, h([
                            Lc(e.f)
                        ]))
                    ]),
                    h([
                        i
                    ])
                ])))
            ])),
            A2(ms, v, h([
                A2(Qo, h([
                    Ho("flex items-center gap-1")
                ]), h([
                    A2(Xc, h([
                        Ho("text-sm")
                    ]), h([
                        Lc(d)
                    ])),
                    b,
                    A2(Xc, h([
                        Ho("text-sm"),
                        Io(h([
                            s("hidden", a(n.ac, Or))
                        ]))
                    ]), h([
                        Lc("//")
                    ])),
                    A2(Qo, h([
                        Ho("flex items-center gap-1")
                    ]), function() {
                        var r = n.ac;
                        if (r.$) return v;
                        var e = Gt(r.a), t = A2(Qo, h([
                            Ho("flex items-center ml-1 text-xs opacity-50")
                        ]), h([
                            A2(Xc, v, h([
                                Lc("(")
                            ])),
                            A2(oc, h([
                                Tc(Nf(e.aY).G),
                                Ho("w-5 opacity-50 mx-1")
                            ]), v),
                            A2(Xc, v, h([
                                Lc(")")
                            ]))
                        ])), u = A3(o, e.aw, .5, 1).a, a = A2(Qo, h([
                            Ho("flex items-center tooltip"),
                            A2(Bo, "data-tip", "Estimated yield range")
                        ]), h([
                            A2(oc, h([
                                Tc(Nf(e.aw).G),
                                Ho("w-5")
                            ]), v),
                            A2(Xc, h([
                                Ho("text-xs ml-1")
                            ]), h([
                                Lc(u)
                            ]))
                        ]));
                        return h([
                            a,
                            t
                        ]);
                    }())
                ]))
            ])),
            A2(ms, h([
                Ho("overflow-hidden relative flex justify-end items-center h-[70px]")
            ]), h([
                A6(uf, n, t, p, vs(r), 0, h([
                    Lc(c)
                ]))
            ]))
        ]));
    }), ws = On("table"), xs = On("tbody"), ys = On("th"), $s = On("thead"), ks = F2(function(n, r) {
        var e, t = Ni(r), u = A2(Re, function(r) {
            var e = r.a, t = r.b, u = c(A2(Ga, n.v, e), t) > -1;
            return A2(Qo, h([
                Ho("flex items-center gap-1"),
                Io(h([
                    s("opacity-50", !u)
                ]))
            ]), h([
                A2(oc, h([
                    Ho("size-4"),
                    Tc(Nf(e).G)
                ]), v),
                A2(Xc, h([
                    Ho("text-xs"),
                    Io(h([
                        s("text-error", !u)
                    ]))
                ]), h([
                    Lc(gc(t))
                ]))
            ]));
        }, t.a5), a = A2(Pi, n.as, r), i = c(a, t.bu) > -1, o = function() {
            if (0 >= a) return "No effect yet";
            var n = t.aC.H;
            switch(n.$){
                case 0:
                    return "+" + gc(Cf(n.a * a * 100) / 1) + "% yield";
                case 1:
                    return "+" + gc(Cf(n.a * a * 100) / 1) + "% speed";
                case 2:
                    return "+" + gc(function(n) {
                        return n / 1;
                    }(Cf(n.a * a * 100))) + "% buff strength";
                default:
                    return "+" + gc(function(n) {
                        return n / 1;
                    }(Cf(n.a * a * 100))) + "% xp gain";
            }
        }(), f = !i && A3(za, F3(function(r, e, t) {
            return t && c(A2(Ga, n.v, r), e) > -1;
        }), !0, t.a5);
        return A2(Fo, h([
            Ho("list-row")
        ]), h([
            A2(Qo, v, h([
                A2(oc, h([
                    Ho("size-10 rounded-box"),
                    Tc(t.aC.G)
                ]), v)
            ])),
            A2(Qo, v, h([
                A2(Qo, v, h([
                    Lc(t.bc)
                ])),
                A2(Qo, h([
                    Ho("text-xs uppercase font-semibold opacity-60")
                ]), h([
                    Lc(t.aC.bq)
                ]))
            ])),
            A2(Qo, h([
                Ho("flex flex-col items-center gap-1")
            ]), h([
                A2(Qo, h([
                    Ho("text-sm font-bold")
                ]), h([
                    Lc("Level " + Mr(a) + "/" + Mr(t.bu))
                ])),
                A2(Qo, h([
                    Ho("text-xs")
                ]), h([
                    Lc(o)
                ]))
            ])),
            i ? A2(Qo, h([
                Ho("text-sm font-bold text-success")
            ]), h([
                Lc("MAX LEVEL")
            ])) : A2(Qo, h([
                Ho("flex flex-col gap-1")
            ]), u),
            A2(So, h([
                Ho("btn btn-sm btn-primary"),
                Io(h([
                    s("btn-disabled", !f || i),
                    s("opacity-50", !f || i)
                ])),
                Vo((e = r, {
                    $: 16,
                    a: e
                }))
            ]), h([
                Lc(i ? "MAX" : "UPGRADE")
            ]))
        ]));
    }), js = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zs = F2(function(n, r) {
        return A2(Rn, n, $i(r));
    })("checked"), Gs = A2(qt, h([
        "target",
        "checked"
    ]), xt), _s = Do("type"), Cs = h([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]), As = Do("name"), Bs = function(n) {
        return A2(Kn, "tabIndex", Mr(n));
    }, Ss = F2(function(n, r) {
        return A2(Po, n, co(r));
    }), Ds = Do("value"), Hs = F2(function(n, r) {
        var e = r.b;
        return {
            y: b(r.y, {
                a4: Xr(n)
            }),
            b: e
        };
    }), Is = F2(function(n, r) {
        var e = Ii(h([
            h([
                0,
                1,
                2
            ]),
            A2(Ei, function(r) {
                return A2(Ss, n.h, r);
            }, Cs)
        ]));
        return A2(Qo, h([
            Ho("dropdown dropdown-top dropdown-start")
        ]), h([
            A2(Qo, h([
                Bs(0),
                A2(Bo, "role", "button"),
                Ho("btn m-1")
            ]), h([
                Lc("Theme"),
                A2(xf, v, A2(Hs, "inline-block opacity-60", A2(yf, 16, Xf)))
            ])),
            A2(ss, h([
                Bs(0),
                Ho("dropdown-content bg-base-300 rounded-box z-1 w-52 p-2 shadow-2xl")
            ]), A2(Re, function(n) {
                var e, t = a(n, r.$ ? 0 : r.a);
                return A2(Fo, v, h([
                    A2(No, h([
                        _s("radio"),
                        As("theme-dropdown"),
                        Ho("theme-controller btn btn-sm btn-block btn-ghost justify-start"),
                        A2(Bo, "aria-label", Si(n)),
                        Ds(Si(n)),
                        zs(t),
                        Vo((e = n, {
                            $: 3,
                            a: e
                        }))
                    ]), v)
                ]));
            }, e))
        ]));
    });
    ya = {
        Main: {
            init: rt({
                dR: function(n) {
                    var r, e, t = n.co, u = n.b5, a = xu(n.b6), i = A2(Xt, mt(h([
                        pu(r = a),
                        (e = r, A2(et, "v0.2", A3(Kt, "dwarfXpButtonStatuses", nu(St), A3(Kt, "dwarfXp", Zt(A2(He, It, ht)), A3(Kt, "missionStatuses", Vt, A3(Kt, "credits", ht, A3(Kt, "level", Qt, A4(Nt, "theme", A2(He, Xr, Ut), Or, A3(Kt, "currentTab", vu, A3(Kt, "currentTime", Ft, Qe(F8(function(n, r, t, u, a, i, o, c) {
                            return {
                                S: v,
                                a6: r,
                                a7: n,
                                aF: At,
                                bo: h([
                                    0,
                                    3
                                ]),
                                D: Ht,
                                al: o,
                                _: c,
                                h: u,
                                bv: Or,
                                v: yu(0),
                                ac: Or,
                                ad: i,
                                aQ: a,
                                as: Rt(0),
                                bA: Dt,
                                Q: e,
                                bG: t
                            };
                        })))))))))))),
                        $u
                    ])), u);
                    if (i.$) {
                        var o = i.a;
                        return s(b(A2(Lu, a, Mt(t)), {
                            bv: Xr(o)
                        }), Eu);
                    }
                    return s(i.a, Eu);
                },
                ez: function() {
                    var n;
                    return Ou(h([
                        (n = qu, na(Yu(n))),
                        ja(A2(He, Xu, A2(et, "key", dt)))
                    ]));
                },
                eI: _o,
                eJ: function(n) {
                    return A2(Qo, h([
                        Ho("w-screen h-screen overflow-hidden flex flex-col items-center bg-base-100")
                    ]), h([
                        us(n),
                        A2(Qo, h([
                            Ho("flex w-full drawer drawer-open")
                        ]), Ii(h([
                            h([
                                A2(No, h([
                                    Yo("my-drawer"),
                                    _s("checkbox"),
                                    Ho("drawer-toggle")
                                ]), v),
                                A2(Qo, h([
                                    Ho("drawer-side w-48"),
                                    A2(Bo, "style", "scroll-behavior: smooth; scroll-padding-top:5rem")
                                ]), h([
                                    A2(Mo, h([
                                        qo("my-drawer"),
                                        Ho("drawer-overlay"),
                                        A2(Bo, "aria-label", "close sidebar")
                                    ]), v),
                                    A2(Ao, h([
                                        Ho("bg-base-100 overflow-y-scroll h-full w-full")
                                    ]), h([
                                        A2(Qo, h([
                                            Ho("sticky top-0 z-10 w-full bg-opacity-90 py-3 backdrop-blur-sm flex")
                                        ]), h([
                                            as
                                        ])),
                                        A2(ss, h([
                                            Ho("menu w-full px-4 py-0")
                                        ]), h([
                                            A2($f, n, 0),
                                            A2($f, n, 1),
                                            A2($f, n, 3),
                                            A2($f, n, 2),
                                            A2(Fo, v, v),
                                            A2($f, n, 4)
                                        ]))
                                    ]))
                                ])),
                                A2(Qo, h([
                                    Ho("drawer-content w-full h-full")
                                ]), h([
                                    A2(Qo, h([
                                        Ho("flex h-full")
                                    ]), h([
                                        function() {
                                            switch(n.a6){
                                                case 0:
                                                    return function(n) {
                                                        var r, e, t = A2(Ei, os(n.h), Qa), u = A2(Re, Pc, A2(Ei, function(n) {
                                                            switch(n.H.$){
                                                                case 0:
                                                                case 1:
                                                                    return !0;
                                                                default:
                                                                    return !1;
                                                            }
                                                        }, Ki(n)));
                                                        return A2(Qo, h([
                                                            Mc.aj
                                                        ]), h([
                                                            A2(Qo, h([
                                                                Mc.ao
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Ho("relative w-full")
                                                                ]), h([
                                                                    A2(Qo, h([
                                                                        Qc,
                                                                        Ho("text-center mx-auto")
                                                                    ]), h([
                                                                        A2(tc, v, h([
                                                                            Lc("Missions")
                                                                        ]))
                                                                    ])),
                                                                    A2(Qo, h([
                                                                        Ho("absolute right-0 top-1/2 -translate-y-1/2 flex items-center gap-2"),
                                                                        Io(h([
                                                                            s("hidden", 1 >= Jr(bs(n.h)))
                                                                        ]))
                                                                    ]), h([
                                                                        (e = n.ac, e.$ ? A2(So, h([
                                                                            Ho("btn btn-md"),
                                                                            A2(Bo, "style", "anchor-name:--anchor-1"),
                                                                            A2(Bo, "popovertarget", "popover-1")
                                                                        ]), h([
                                                                            Lc("Select a biome")
                                                                        ])) : (r = e.a, A2(So, h([
                                                                            Ho("btn btn-md w-72 h-12 rounded overflow-hidden relative shadow"),
                                                                            A2(Bo, "style", "anchor-name:--anchor-1"),
                                                                            A2(Bo, "popovertarget", "popover-1"),
                                                                            A2(Hf, "background-image", "url(" + Gt(r).dO + ")"),
                                                                            Ho("bg-cover bg-no-repeat bg-center")
                                                                        ]), h([
                                                                            A2(Qo, h([
                                                                                Ho("absolute top-0 left-0 bg-base-100 text-xs px-1 py-0.5 leading-none opacity-60")
                                                                            ]), h([
                                                                                Lc(Gt(r).bc)
                                                                            ]))
                                                                        ])))),
                                                                        A2(So, h([
                                                                            Ho("btn btn-md btn-square"),
                                                                            A2(Bo, "popovertarget", "popover-1")
                                                                        ]), h([
                                                                            A2(xf, v, is)
                                                                        ]))
                                                                    ])),
                                                                    A2(Qo, h([
                                                                        Ho("dropdown"),
                                                                        A2(Bo, "popover", ""),
                                                                        Yo("popover-1"),
                                                                        A2(Bo, "style", "position-anchor:--anchor-1")
                                                                    ]), h([
                                                                        ds(n)
                                                                    ]))
                                                                ]))
                                                            ])),
                                                            A2(Qo, h([
                                                                Mc.aB
                                                            ]), u),
                                                            A2(Qo, h([
                                                                Mc.ak
                                                            ]), h([
                                                                A2(ws, h([
                                                                    Ho("table table-sm w-[750px] max-w-full")
                                                                ]), h([
                                                                    A2($s, v, h([
                                                                        A2(hs, v, h([
                                                                            A2(ys, v, h([
                                                                                Lc("Hazard level")
                                                                            ])),
                                                                            A2(ys, v, h([
                                                                                Lc("Yield")
                                                                            ])),
                                                                            A2(ys, h([
                                                                                Ho("text-end")
                                                                            ]), h([
                                                                                Lc("Status")
                                                                            ]))
                                                                        ]))
                                                                    ])),
                                                                    A2(xs, v, A2(Re, gs(n), t))
                                                                ]))
                                                            ]))
                                                        ]));
                                                    }(n);
                                                case 1:
                                                    return function(n) {
                                                        var r = A2(Ei, function(n) {
                                                            return 3 === n.H.$;
                                                        }, Ki(n)), e = A2(Ei, Rc(n.h), Ia);
                                                        return A2(Qo, h([
                                                            Mc.aj
                                                        ]), h([
                                                            A2(Qo, h([
                                                                Mc.ao
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Qc
                                                                ]), h([
                                                                    A2(tc, v, h([
                                                                        Lc("Dwarf Leveling")
                                                                    ]))
                                                                ]))
                                                            ])),
                                                            A2(Qo, h([
                                                                Mc.aB
                                                            ]), A2(Re, Pc, r)),
                                                            A2(Qo, h([
                                                                Mc.ak
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Ho("flex flex-col item-center gap-4 w-[300px]")
                                                                ]), A2(Re, function(r) {
                                                                    var e = fi(Ui(n)), t = ii(r), u = e > 0 ? "+" + af(A2(si, 1 + e, t.bI)) + " xp" : "+" + af(t.bI) + " xp";
                                                                    return A6(uf, n, A2(ai, n._, r), t.aI, Fc(r), 1, h([
                                                                        Lc(u),
                                                                        Lc(" to random dwarf")
                                                                    ]));
                                                                }, e))
                                                            ]))
                                                        ]));
                                                    }(n);
                                                case 2:
                                                    return function(n) {
                                                        return A2(Qo, h([
                                                            Mc.aj
                                                        ]), h([
                                                            A2(Qo, h([
                                                                Mc.ao
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Qc
                                                                ]), h([
                                                                    A2(tc, v, h([
                                                                        Lc("Projects")
                                                                    ]))
                                                                ]))
                                                            ])),
                                                            A2(Qo, h([
                                                                Mc.ak
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Ho("list bg-base-100 rounded-box shadow-md")
                                                                ]), h([
                                                                    A2(Qo, h([
                                                                        Ho("p-4 pb-2 text-xs opacity-60 tracking-wide")
                                                                    ]), h([
                                                                        Lc("Available Projects")
                                                                    ])),
                                                                    A2(Qo, v, A2(Re, ks(n), Li))
                                                                ]))
                                                            ]))
                                                        ]));
                                                    }(n);
                                                case 3:
                                                    return function(n) {
                                                        return A2(Qo, h([
                                                            Mc.aj
                                                        ]), h([
                                                            A2(Qo, h([
                                                                Mc.ao
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Qc
                                                                ]), h([
                                                                    A2(tc, v, h([
                                                                        Lc("Abyss Bar")
                                                                    ]))
                                                                ]))
                                                            ])),
                                                            A2(Qo, h([
                                                                Mc.aB
                                                            ]), A2(Re, Pc, A2(Ei, function(n) {
                                                                return 2 === n.H.$;
                                                            }, Ki(n)))),
                                                            A2(Qo, h([
                                                                Mc.ak
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Ho("flex flex-col items-center gap-4 max-w-[750px]")
                                                                ]), h([
                                                                    sc(n.S) ? Lc("") : A2(Qo, h([
                                                                        Ho("card bg-base-300 shadow-lg w-full")
                                                                    ]), h([
                                                                        A2(Qo, h([
                                                                            Ho("card-body")
                                                                        ]), h([
                                                                            A2(uc, h([
                                                                                Ho("card-title")
                                                                            ]), h([
                                                                                Lc("Current Daily Special")
                                                                            ])),
                                                                            A2(Qo, h([
                                                                                Ho("flex flex-wrap gap-4")
                                                                            ]), A2(Re, function(r) {
                                                                                var e = r.a, t = r.b, u = st(e), a = A2(ic, Oa, t), i = A2(Fi, n, e), o = A2(ec, Oa, t), c = xe(cc(o)), f = A2(bc, 60, xe(fc(o))), s = !A2(Ri, lc, o) && a ? 60 : A2(bc, 60, xe(o)), l = A3(Ic, 2, "0", Mr(c)) + ":" + A3(Ic, 2, "0", Mr(f)) + ":" + A3(Ic, 2, "0", Mr(s));
                                                                                return A2(Qo, h([
                                                                                    Ho("flex items-center gap-2")
                                                                                ]), h([
                                                                                    A2(oc, h([
                                                                                        Tc(u.G),
                                                                                        Ho("w-8 h-8")
                                                                                    ]), v),
                                                                                    A2(Qo, h([
                                                                                        Ho("flex flex-col")
                                                                                    ]), h([
                                                                                        A2(Xc, h([
                                                                                            Ho("font-medium")
                                                                                        ]), h([
                                                                                            Lc(u.f)
                                                                                        ])),
                                                                                        A2(Xc, h([
                                                                                            Ho("text-sm opacity-70")
                                                                                        ]), h([
                                                                                            Lc(Hc(i.H))
                                                                                        ])),
                                                                                        A2(Xc, h([
                                                                                            Ho("text-xs opacity-50")
                                                                                        ]), h([
                                                                                            Lc(l)
                                                                                        ]))
                                                                                    ]))
                                                                                ]));
                                                                            }, n.S))
                                                                        ]))
                                                                    ])),
                                                                    function() {
                                                                        var r = n.aF;
                                                                        if (r.$) {
                                                                            var e = r.a, t = A2(ic, Na, e);
                                                                            return A2(Qo, h([
                                                                                Ho("flex flex-col items-center gap-2")
                                                                            ]), h([
                                                                                A2(Wo, v, h([
                                                                                    Lc("Select a new daily special in")
                                                                                ])),
                                                                                A2(Yc, A2(ec, Na, e), t)
                                                                            ]));
                                                                        }
                                                                        return A2(Qo, h([
                                                                            Ho("flex flex-col gap-4")
                                                                        ]), h([
                                                                            A2(Wo, v, h([
                                                                                Lc("Select a "),
                                                                                A2(Nc, v, h([
                                                                                    Lc("daily special")
                                                                                ])),
                                                                                Lc(" to give your crew an "),
                                                                                A2(Nc, h([
                                                                                    Ho("underline")
                                                                                ]), h([
                                                                                    Lc("awesome buff")
                                                                                ]))
                                                                            ])),
                                                                            A2(Qo, h([
                                                                                Ho("flex items-center gap-4")
                                                                            ]), A2(Re, Oc(n), n.bo))
                                                                        ]));
                                                                    }()
                                                                ]))
                                                            ]))
                                                        ]));
                                                    }(n);
                                                default:
                                                    return function(n) {
                                                        var r;
                                                        return A2(Qo, h([
                                                            Mc.aj
                                                        ]), h([
                                                            A2(Qo, h([
                                                                Mc.ao
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Qc
                                                                ]), h([
                                                                    A2(tc, v, h([
                                                                        Lc("Settings")
                                                                    ]))
                                                                ]))
                                                            ])),
                                                            A2(Qo, h([
                                                                Mc.aB
                                                            ]), v),
                                                            A2(Qo, h([
                                                                Mc.ak
                                                            ]), h([
                                                                A2(Qo, h([
                                                                    Ho("flex flex-col items-center gap-4 w-full max-w-[750px]")
                                                                ]), h([
                                                                    A2(So, h([
                                                                        Ho("btn"),
                                                                        Vo({
                                                                            $: 17,
                                                                            a: "my_modal_1"
                                                                        })
                                                                    ]), h([
                                                                        Lc("Reset game")
                                                                    ]))
                                                                ])),
                                                                A2(Qo, h([
                                                                    Ho("divider")
                                                                ]), v),
                                                                A2(Qo, h([
                                                                    Qc
                                                                ]), h([
                                                                    A2(uc, v, h([
                                                                        Lc("Admin crimes")
                                                                    ])),
                                                                    A2(Qo, h([
                                                                        Ho("flex items-center gap-1")
                                                                    ]), h([
                                                                        A2(Mo, h([
                                                                            qo("button-no-cd")
                                                                        ]), h([
                                                                            Lc("No CD button")
                                                                        ])),
                                                                        A2(No, h([
                                                                            _s("checkbox"),
                                                                            Ho("checkbox"),
                                                                            Yo("button-no-cd"),
                                                                            zs(n.D.c8),
                                                                            (r = js, A2(Jo, "change", A2(He, r, Gs)))
                                                                        ]), v)
                                                                    ]))
                                                                ]))
                                                            ]))
                                                        ]));
                                                    }(n);
                                            }
                                        }(),
                                        A2(Qo, h([
                                            Ho("h-full w-48 min-w-48 items-center p-4 overflow-y-scroll")
                                        ]), h([
                                            A2(Qo, h([
                                                Ho("flex flex-col gap-4"),
                                                Io(h([
                                                    s("hidden", !Eo(n.h))
                                                ]))
                                            ]), Ii(h([
                                                h([
                                                    A2(Qo, h([
                                                        Ho("w-full flex items-center justify-center prose")
                                                    ]), h([
                                                        A2(Oo, v, h([
                                                            Lc("Your crew")
                                                        ]))
                                                    ]))
                                                ]),
                                                A2(Re, If(n), oi)
                                            ])))
                                        ]))
                                    ]))
                                ]))
                            ]),
                            h([
                                A2(Qo, h([
                                    Ho("fixed bottom-0 left-0 ml-6 mb-6")
                                ]), h([
                                    A2(Is, n, n.bG)
                                ]))
                            ]),
                            function() {
                                var r = n.bv;
                                if (r.$) return v;
                                var e = r.a;
                                return h([
                                    A2(Qo, h([
                                        Ho("fixed bottom-0 left-0 bg-error text-error-content rounded-lg p-4")
                                    ]), h([
                                        Lc(ce(e))
                                    ]))
                                ]);
                            }()
                        ]))),
                        A3(Ko, "dialog", h([
                            Yo("my_modal_1"),
                            Ho("modal")
                        ]), h([
                            A2(Qo, h([
                                Ho("modal-box")
                            ]), h([
                                A2(Oo, h([
                                    Ho("text-lg font-bold")
                                ]), h([
                                    Lc("Reset Game")
                                ])),
                                A2(Wo, h([
                                    Ho("py-4")
                                ]), h([
                                    Lc("Are you sure you want to reset the game? All progress will be lost.")
                                ])),
                                A2(Qo, h([
                                    Ho("modal-action")
                                ]), h([
                                    A2(Xo, h([
                                        Ro("dialog")
                                    ]), h([
                                        A2(So, h([
                                            Ho("btn btn-error"),
                                            Vo(Co)
                                        ]), h([
                                            Lc("Yes, Reset Game")
                                        ]))
                                    ])),
                                    A2(Xo, h([
                                        Ro("dialog")
                                    ]), h([
                                        A2(So, h([
                                            Ho("btn")
                                        ]), h([
                                            Lc("Cancel")
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(Xo, h([
                                A2(Bo, "method", "dialog"),
                                Ho("modal-backdrop")
                            ]), h([
                                A2(So, v, h([
                                    Lc("close")
                                ]))
                            ]))
                        ]))
                    ]));
                }
            })(A2(De, function(n) {
                return A2(De, function(r) {
                    return A2(De, function(e) {
                        return Qe({
                            b5: e,
                            b6: r,
                            co: n
                        });
                    }, A2(et, "initialGame", Ot));
                }, A2(et, "initialSeed", Qt));
            }, A2(et, "now", Qt)))(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? u(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, ya) : n.Elm = ya;
}($a0b4f895e1596b3b$exports);


function $35da740d59af89ba$var$getRandomInt() {
    return Math.floor(Math.random() * 999999);
}
const $35da740d59af89ba$var$saveGameKey = 'drg-mc:saveGame';
const $35da740d59af89ba$var$saveGame = localStorage.getItem($35da740d59af89ba$var$saveGameKey);
const $35da740d59af89ba$var$initialGame = $35da740d59af89ba$var$saveGame ? JSON.parse($35da740d59af89ba$var$saveGame) : {};
const $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.querySelector("main"),
    flags: {
        initialSeed: $35da740d59af89ba$var$getRandomInt(),
        initialGame: $35da740d59af89ba$var$initialGame,
        now: Date.now()
    }
});
$35da740d59af89ba$var$app.ports.saveGame.subscribe(function(game) {
    localStorage.setItem($35da740d59af89ba$var$saveGameKey, JSON.stringify(game));
});


//# sourceMappingURL=index.3c71200b.js.map
